<template>
	<div class="editor">
		<!-- 标题 -->
		<div class="editor-title flex_c">
			<!-- 图片 -->
			<img :src="curItem.icon || projectinfo.image_url" width="20px" />
			<!-- <i class="el-icon-s-tools" style="font-size: 16px"></i> -->
			<span style="margin-left: 5px">
				<!-- {{
        selectedIndex === "page" ? data.page.name : curItem.name
      }} -->
				{{ selectedIndex === "page" ? projectinfo.title : curItem.name }}
			</span>
		</div>

		<!-- 编辑器: 标题栏 -->
		<div v-if="selectedIndex === 'page'" class="editor-content editor-content-banner">
			<!-- <el-tabs>
        <el-tab-pane key="1" label="页面设置"> -->
			<div class="block-box">
				<!-- <div class="block-title">基本信息</div> -->
				
				<div class="block-item has-tips block-item-class mt10">
					<span class="label">页面名称</span>
					<div class="flex-box">
						<el-input size="small" v-model="data.page.params.name" />
					</div>
				</div>
				<div class="block-item has-tips block-item-class  ">
					<span class="label">页面背景</span>
					<div class="flex-box" style="margin-top: 6px;">
						<el-radio-group v-model="data.page.params.zubackground" type="button">
							<el-radio label="0">纯色</el-radio>
							<el-radio label="1">渐变</el-radio>
						</el-radio-group>
					</div>
				</div>
				<div v-if="data.page.params.zubackground=='1'" class="block-item block-item-class">
					<span class="label">顶部颜色</span>
					<div class="item-colorPicker">
						<div class="color-picker-box">
							<el-color-picker size="small" v-model="data.page.style.backgroundPageTop"
								defaultColor="#fff" />
						</div>
						<div class="reset-color">
							<div class="ipt">
								<SInput v-model="data.page.style.backgroundPageTop" width="100px" height="32px"
									border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
							</div>
							<div class="color-txt" @click="
				      onEditorResetColor(
				        data.page.style,
				        'backgroundPageTop',
				        '#fff'
				      )
				    "> 重置
							</div>
						</div>
					</div>
				</div>
				<div class="block-item block-item-class">
					<span class="label">背景颜色</span>
					<div class="item-colorPicker">
						<div class="color-picker-box">
							<el-color-picker size="small" backgroundPage v-model="data.page.style.backgroundPage"
								defaultColor="#fff" />
						</div>
						<div class="reset-color">
							<div class="ipt">
								<SInput v-model="data.page.style.backgroundPage" width="100px" height="32px"
									border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
							</div>
							<div class="color-txt" @click="
				      onEditorResetColor(
				        data.page.style,
				        'backgroundPage',
				        '#fff'
				      )
				    "> 重置
							</div>
						</div>
					</div>
				</div>
				<div v-if="data.page.params.zubackground=='1'" class="block-item block-item-class">
					<span class="label">渐变距离</span>
					<div class="item-slider">
						<el-slider style="width: 100%" v-model="data.page.style.backgroundPageHeight" :min="0" :max="1000" />
					</div>
					<el-input type="number" @input="e=>changeInputPage(e,'backgroundPageHeight')" v-model="data.page.style.backgroundPageHeight"
						size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
						<span slot="suffix" class="input_text" style="">PX</span>
					</el-input>
				</div>
				<!-- <div class="block-item has-tips block-item-class  ">
					<span class="label">顶部导航</span>
					<div class="flex-box" style="margin-top: 6px;">
						<el-radio-group v-model="data.page.params.model_type" type="button">
							<el-radio label="0">默认</el-radio>
							<el-radio label="1">自定义</el-radio>
							<el-radio label="2">沉浸式</el-radio>
						</el-radio-group>
						<div class="tips">当导航选择沉浸式，背景样式设置仅在APP、微信小程序中生效</div>
					</div>
				</div> -->
				<!-- <div v-if="data.page.params.model_type==1" class="block-item block-item-class">
					<span class="label">顶部背景</span>
					<el-radio-group v-model="data.page.params.bgstyle" type="button">
						<el-radio :label="1">纯色</el-radio>
						<el-radio :label="2">图片</el-radio>
					</el-radio-group>
				</div>
				<div v-if="data.page.params.bgstyle==2&&data.page.params.model_type==1"
					class="block-item has-tips block-item-class">
					<span class="label">导航图片</span>
					<div class="flex-box">
						<SImage v-model="data.page.style.titleBackgroundImg" />
						<div class="tips">建议尺寸750*196</div>
					</div>
				</div> -->
				<!-- <div v-if="data.page.params.bgstyle==1&&data.page.params.model_type==1"
					class="block-item block-item-class">
					<span class="label">顶部背景</span>
					<div class="item-colorPicker">
						<div class="color-picker-box">
							<el-color-picker size="small" v-model="data.page.style.titleBackgroundColor"
								defaultColor="#fff" />
						</div>
						<div class="reset-color">
							<div class="ipt">
								<SInput v-model="data.page.style.titleBackgroundColor" width="100px" height="32px"
									border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
							</div>
							<div class="color-txt" @click="
			          onEditorResetColor(
			            data.page.style,
			            'titleBackgroundColor',
			            '#fff'
			          )
			        ">
								重置
							</div>
						</div>
					</div>
				</div> -->
				<div  class="block-item block-item-class">
					<span class="label">顶部背景</span>
					<div class="item-colorPicker">
						<div class="color-picker-box">
							<el-color-picker size="small" v-model="data.page.style.titleBackgroundColor"
								defaultColor="#fff" />
						</div>
						<div class="reset-color">
							<div class="ipt">
								<SInput v-model="data.page.style.titleBackgroundColor" width="100px" height="32px"
									border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
							</div>
							<div class="color-txt" @click="
			          onEditorResetColor(
			            data.page.style,
			            'titleBackgroundColor',
			            '#fff'
			          )
			        ">
								重置
							</div>
						</div>
					</div>
				</div>
				<div class="block-item has-tips block-item-class">
					<span class="label">导航标题</span>
					<div class="flex-box">
						<el-input size="small" v-model="data.page.params.title" />
						<!-- <div class="tips">用户端端顶部显示的标题</div> -->
					</div>
				</div>
				<div class="block-item block-item-class">
					<span class="label">文字颜色</span>
					<el-radio-group v-model="data.page.style.titleTextColor" type="button">
						<el-radio label="white">白色</el-radio>
						<el-radio label="black">黑色</el-radio>
					</el-radio-group>
				</div>
				<!-- <div v-if="data.page.params.model_type==1" class="block-item has-tips block-item-class mt10">
					<span class="label">多门店显示</span>
					<div class="flex-box">
						<el-radio-group v-model="data.page.params.storeShow" type="button">
							<el-radio label="1">显示</el-radio>
							<el-radio label="2">不显示</el-radio>
						</el-radio-group>
					</div>
				</div>
				<div v-if="data.page.params.model_type==1&&data.page.params.storeShow==1"
					class="block-item block-item-class">
					<span class="label">多门店文字</span>
					<div class="item-colorPicker">
						<div class="color-picker-box">
							<el-color-picker size="small" v-model="data.page.style.searchTitTextColor"
								defaultColor="#fff" />
						</div>
						<div class="reset-color">
							<div class="ipt">
								<SInput v-model="data.page.style.searchTitTextColor" width="100px" height="32px"
									border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
							</div>
							<div class="color-txt" @click=" onEditorResetColor( data.page.style, 'searchTitTextColor', '#fff' ) "> 重置 </div>
						</div>
					</div>
				</div>
				<div v-if="data.page.params.model_type==1" class="block-item has-tips block-item-class mt10">
					<span class="label">搜索框显示</span>
					<div class="flex-box">
						<el-radio-group v-model="data.page.params.searchShow" type="button">
							<el-radio label="1">显示</el-radio>
							<el-radio label="2">不显示</el-radio>
						</el-radio-group>
					</div>
				</div> -->
				<!-- <div v-if="data.page.params.model_type==1&&data.page.params.searchShow==1"
					class="block-item block-item-class">
					<span class="label">搜索框文字</span>
					<div class="item-colorPicker">
						<div class="color-picker-box">
							<el-color-picker size="small" v-model="data.page.style.searchTextColor"
								defaultColor="#fff" />
						</div>
						<div class="reset-color">
							<div class="ipt">
								<SInput v-model="data.page.style.searchTextColor" width="100px" height="32px"
									border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
							</div>
							<div class="color-txt" @click="
			          onEditorResetColor(
			            data.page.style,
			            'searchTextColor',
			            '#fff'
			          )
			        ">
								重置
							</div>
						</div>
					</div>
				</div> -->
				<!-- <div v-if="data.page.params.model_type==1&&data.page.params.searchShow==1"
					class="block-item block-item-class">
					<span class="label">搜索框背景</span>
					<div class="item-colorPicker">
						<div class="color-picker-box">
							<el-color-picker size="small" v-model="data.page.style.searchBackgroudColor"
								defaultColor="#fff" />
						</div>
						<div class="reset-color">
							<div class="ipt">
								<SInput v-model="data.page.style.searchBackgroudColor" width="100px" height="32px"
									border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
							</div>
							<div class="color-txt" @click="
			          onEditorResetColor(
			            data.page.style,
			            'searchBackgroudColor',
			            '#fff'
			          )
			        ">
								重置
							</div>
						</div>
					</div>
				</div>
				<div v-if="data.page.params.model_type==1&&data.page.params.searchShow==1"
					class="block-item has-tips block-item-class">
					<span class="label">搜索框提示</span>
					<div class="flex-box">
						<el-input size="small" v-model="data.page.params.searchTips" />
						<div class="tips">搜索框内提示内容</div>
					</div>
				</div> -->
				<!-- <div class="block-item has-tips block-item-class">
              <span class="label">分享标题</span>
              <div class="flex-box">
                <el-input size="small" v-model="data.page.params.shareTitle" />
                <div class="tips">用户端转发时显示的标题</div>
              </div>
            </div>
            <div class="block-item has-tips block-item-class">
              <span class="label">分享封面</span>
              <div class="flex-box">
                <SImage v-model="data.page.params.shareImg" />
                <div class="tips">建议尺寸500*400</div>
              </div>
            </div> -->
				<div class="block-item has-tips block-item-class">
					<span class="label">访问权限</span>
					<div class="flex-box" style="margin-top: 4px;">
						<el-radio-group v-model="data.page.params.is_open" type="button">
							<el-radio :label="1">开启</el-radio>
							<el-radio :label="0">关闭</el-radio>
						</el-radio-group>
						<div class="tips">是否需要开启密码访问</div>
					</div>
				</div>
				<div class="block-item has-tips block-item-class" v-if="data.page.params.is_open">
					<span class="label">访问密码</span>
					<div class="flex-box">
						<el-input size="small" type="password" v-model="data.page.params.password" show-password />
						<div class="tips">页面访问密码</div>
					</div>
				</div>
				<div class="block-item has-tips block-item-class">
					<span class="label" style="margin-top: 0">弹窗广告</span>
					<div class="flex-box">
						<el-radio-group v-model="data.page.params.ads_open" type="button">
							<el-radio :label="1">开启</el-radio>
							<el-radio :label="0">关闭</el-radio>
						</el-radio-group>
					</div>
				</div>
				<div class="block-item has-tips block-item-class" v-if="data.page.params.ads_open">
					<span class="label" style="margin-top: 0">定时关闭</span>
					<div class="flex-box">
						<el-input size="small" type="number" v-model.number="data.page.params.timeout" min="1"
							:controls="false">
							<template slot="append">秒</template>
						</el-input>
					</div>
				</div>
				<div class="block-item has-tips block-item-class" v-if="data.page.params.ads_open">
					<span class="label" style="margin-top: 0">切换速度</span>
					<div class="flex-box">
						<el-input size="small" type="number" v-model.number="data.page.params.timeInter" min="1"
							:controls="false">
							<template slot="append">秒</template>
						</el-input>
					</div>
				</div>
				<div class=" " v-if="data.page.params.ads_open">
					<div class="sub-title">添加图片 (最多10张，可拖动排序）</div>
					<draggable :list="data.page.params.adsList" v-bind="{
            	    animation: 120,
            	    filter: 'input',
            	    preventOnFilter: false,
            	  }">
						<div v-for="(item, index) in data.page.params.adsList" :key="index"
							class="block-box drag drage-banner">
							<div class="block-title">
								<!-- <span class="left">图片 {{ index + 1 }}</span> -->
								<a class="link" @click="handleDeleleAd(index)">
									<i class="el-icon-error"></i></a>
							</div>
							<div class="block-item">
								<img src="@/assets/icon/icon-move.png" alt="" style="width: 20px; height: 20px" />
								<div class="block-item-custom">
									<SImage width="70px" height="70px" v-model="item.imgUrl" tips="建议尺寸750×400"
										@update="item.imgName = $event.filename" />
								</div>
								<div class="block-item-common">
									<!-- <div class="block-item-common-row">
            	          <span class="label">图片</span>
            	          <span class="label value">{{ item.imgName }}</span>
            	        </div> -->
									<div class="block-item-common-row">
										<!-- <span class="label">选择链接</span> -->
										<SLink v-model="item.link" />
									</div>
									<span>建议弹框图片所有宽高比例一致，否则会影响用户体验</span>
								</div>
							</div>
						</div>
					</draggable>
					<div v-if="data.page.params.adsList.length < 10" class="data-add">
						<el-button icon="plus" @click="handleAddAd(10)">添加弹框广告</el-button>
					</div>
				</div>
			</div>
			<!-- </el-tab-pane>
        <el-tab-pane key="2" label="标题栏设置"> -->
			<!-- </el-tab-pane>
      </el-tabs> -->
		</div>

		<template v-if="data.items.length && curItem">
			<!-- 搜索栏 -->
			<div v-if="curItem.type == 'search'" class="editor-content editor-content-banner">
				<!-- <el-tabs>
          <el-tab-pane key="1" label="内容设置"> -->
				<div class="block-box">
					<!-- <div class="block-title">功能设置</div> -->
					<div class="block-item block-item-class">
						<span class="label">提示文字</span>
						<el-input size="small" v-model="curItem.params.placeholder" />
					</div>
					<!-- <div class="block-item block-item-class">
                <span class="label">吸顶规则</span>
                <el-radio-group v-model="curItem.params.sticky" type="button">
                  <el-radio :label="false">不吸顶</el-radio>
                  <el-radio :label="true">到顶部时吸顶</el-radio>
                </el-radio-group>
              </div>
              <div class="block-item tips">
                <div class="tips">滚动至页面顶部时固定</div>
              </div> -->
				</div>
				<!-- </el-tab-pane>
          <el-tab-pane key="2" label="样式设置"> -->
				<div class="block-box">
					<!-- <div class="block-title">内容样式</div> -->
					<div class="block-item block-item-class">
						<span class="label">样式设置</span>
						<el-radio-group v-model="curItem.style.searchStyle" type="button">
							<el-radio label="square">方形</el-radio>
							<el-radio label="radius">圆角</el-radio>
							<el-radio label="round">圆弧</el-radio>
						</el-radio-group>
					</div>
					<div class="block-item block-item-class">
						<span class="label">文字对齐</span>
						<el-radio-group v-model="curItem.style.textAlign" type="button">
							<el-radio label="left">居左</el-radio>
							<el-radio label="center">居中</el-radio>
							<el-radio label="right">居右</el-radio>
						</el-radio-group>
					</div>
					<div class="block-item block-item-class">
						<span class="label">搜索背景</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.background"
									defaultColor="#f9f9f9" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.background" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#fff"></SInput>
								</div>
								<div class="color-txt" @click="
					    onEditorResetColor(curItem.style, 'background', '#fff')
					  ">
									重置
								</div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">边框颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.borderColor" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.borderColor" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#fff"></SInput>
								</div>
								<div class="color-txt"
									@click=" onEditorResetColor(curItem.style, 'borderColor', '#fff') ">
									重置
								</div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">文字颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.color" defaultColor="#000" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.color" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#000"></SInput>
								</div>
								<div class="color-txt" @click="
					    onEditorResetColor(curItem.style, 'color', '#000')
					  ">
									重置
								</div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">上圆角</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.radiusTop" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'radiusTop')" v-model="curItem.style.radiusTop"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">下圆角</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.radiusBottom" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'radiusBottom')"
							v-model="curItem.style.radiusBottom" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">上边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingTop" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingTop')"
							v-model="curItem.style.paddingTop" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">下边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingBottom" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingBottom')"
							v-model="curItem.style.paddingBottom" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">左边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingLeft" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingLeft')"
							v-model="curItem.style.paddingLeft" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">右边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingRight" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingRight')"
							v-model="curItem.style.paddingRight" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">组件背景</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.zubackground"
									defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.zubackground" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#fff"></SInput>
								</div>
								<div class="color-txt" @click="
			            onEditorResetColor(curItem.style, 'zubackground', '#fff')
			          ">
									重置
								</div>
							</div>
						</div>
					</div>
					
				</div>
				<!--  </el-tab-pane>
        </el-tabs> -->
			</div>

			<!-- 辅助空白 -->
			<div v-if="curItem.type == 'blank'" class="editor-content editor-content-banner">
				<div class="block-box">
					<!-- <div class="block-title">样式设置</div> -->
					<div class="block-item block-item-class">
						<span class="label">组件高度</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.height" :min="5" :max="200" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'height')" v-model="curItem.style.height"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">背景颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.background" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.background" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
                    onEditorResetColor(curItem.style, 'background', '#fff')
                  ">
									重置
								</div>
							</div>
							<!-- <span
                class="rest-color"
                @click="onEditorResetColor(curItem.style, 'background', '#fff')"
                >重置</span
              >
              <el-color-picker
                size="small"
                v-model="curItem.style.background"
                defaultColor="#fff"
              /> -->
						</div>
					</div>
				</div>
			</div>

			<!-- 辅助线 -->
			<div v-if="curItem.type == 'guide'" class="editor-content editor-content-banner">
				<div class="block-box">
					<!-- <div class="block-title">样式设置</div> -->
					<div class="block-item block-item-class">
						<span class="label">线条样式</span>
						<el-radio-group v-model="curItem.style.lineStyle" type="button">
							<el-radio label="solid">实线</el-radio>
							<el-radio label="dashed">虚线</el-radio>
							<el-radio label="dotted">点状</el-radio>
						</el-radio-group>
					</div>
					<div class="block-item block-item-class">
						<span class="label">线条颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.lineColor" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.lineColor" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
                    onEditorResetColor(curItem.style, 'lineColor', '#000')
                  ">
									重置
								</div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">线条高度</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.lineHeight" :min="0" :max="20" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'lineHeight')"
							v-model="curItem.style.lineHeight" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">上下边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingTop" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingTop')"
							v-model="curItem.style.paddingTop" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">左右边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingLeft" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingLeft')"
							v-model="curItem.style.paddingLeft" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">组件背景</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.background" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.background" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
                    onEditorResetColor(curItem.style, 'background', '#fff')
                  ">
									重置
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 门店切换 -->
			<div v-if="curItem.type == 'stores'" class="editor-content editor-content-banner">
				<div class="block-box">
					<!-- <div class="block-title">样式设置</div> -->
					<div class="block-item block-item-class">
						<span class="label">样式排版</span>
						<el-radio-group v-model="curItem.params.style" type="button">
							<el-radio :label="1">基础版</el-radio>
							<el-radio :label="2">简化版</el-radio>
						</el-radio-group>
					</div>
					<div class="block-item block-item-class">
						<span class="label">上边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingTop" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingTop')"
							v-model="curItem.style.paddingTop" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">下边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingBottom" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingBottom')"
							v-model="curItem.style.paddingBottom" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">左边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingLeft" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingLeft')"
							v-model="curItem.style.paddingLeft" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">右边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingRight" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingRight')"
							v-model="curItem.style.paddingRight" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">背景颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.background" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.background" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
		              onEditorResetColor(curItem.style, 'background', '#fff')
		            ">
									重置
								</div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">名称颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.titlecolor" defaultColor="#000" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.titlecolor" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
			          onEditorResetColor(curItem.style, 'titlecolor', '#000')
			        ">
									重置
								</div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">地址颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.addresscolor"
									defaultColor="#999999" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.addresscolor" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
			          onEditorResetColor(curItem.style, 'addresscolor', '#999999')
			        ">
									重置
								</div>
							</div>
						</div>
					</div>

				</div>
			</div>
			<!-- 富文本 -->
			<div v-if="curItem.type == 'richText'" 
				class="editor-content editor-content-banner">
				<!-- <el-tabs>
          <el-tab-pane key="1" label="内容设置"> -->
				<div class="block-box" style="margin-bottom: 35px;">
					<!-- <div class="block-title">文本内容</div> -->
					<div class="ueditor">
						<tinymce-editor style="width: 480px" :id="'s1'" ref="editor1" :height="600"
							v-model="curItem.params.content" :disabled="false"></tinymce-editor>
						<!--<Ueditor v-model="curItem.params.content" :config="{ initialFrameWidth:  375 }" />-->
					</div>
				</div>
				<!-- </el-tab-pane>
          <el-tab-pane key="2" label="样式设置"> -->
				<div class="block-box">
					<!-- <div class="block-title">组件样式</div> -->
					<div class="block-item block-item-class">
						<span class="label">上边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingTop" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingTop')"
							v-model="curItem.style.paddingTop" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">下边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingBottom" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingBottom')"
							v-model="curItem.style.paddingBottom" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">左边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingLeft" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingLeft')"
							v-model="curItem.style.paddingLeft" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">右边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingRight" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingRight')"
							v-model="curItem.style.paddingRight" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">组件背景</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.background" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.background" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
                        onEditorResetColor(curItem.style, 'background', '#fff')
                      ">
									重置
								</div>
							</div>
							<!-- <span
                    class="rest-color"
                    @click="
                      onEditorResetColor(curItem.style, 'background', '#fff')
                    "
                    >重置</span
                  >
                  <el-color-picker
                    size="small"
                    v-model="curItem.style.background"
                    defaultColor="#fff"
                  /> -->
						</div>
					</div>
				</div>
				<!-- </el-tab-pane>
        </el-tabs> -->
			</div>

			<!-- 店铺公告 -->
			<div v-if="curItem.type == 'notice'" class="editor-content editor-content-banner">
				<!-- <el-tabs>
          <el-tab-pane key="1" label="内容设置"> -->
				<div class="block-box">
					<!-- <div class="block-title">公告文案</div> -->
					<div class="block-item block-item-class">
						<span class="label">内容</span>
						<el-input size="small" v-model="curItem.params.text" />
					</div>
					<div class="block-item block-item-class">
						<span class="label">链接</span>
						<div class="flex-box">
							<SLink v-model="curItem.params.link" />
						</div>
					</div>
				</div>
				<!-- </el-tab-pane>
          <el-tab-pane key="2" label="样式设置"> -->
				<div class="block-box">
					<!-- <div class="block-title">内容样式</div> -->
					<div class="block-item block-item-class">
						<span class="label">文字颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.textColor" defaultColor="#000" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.textColor" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
                        onEditorResetColor(curItem.style, 'textColor', '#000')
                      ">
									重置
								</div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">背景颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.background" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.background" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
                        onEditorResetColor(curItem.style, 'background', '#fff')
                      ">
									重置
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="block-box">
					<!-- <div class="block-title">组件样式</div> -->
					<div class="block-item block-item-class">
						<span class="label">组件背景</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.zubackground"
									defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.zubackground" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
			            onEditorResetColor(curItem.style, 'zubackground', '#fff')
			          "> 重置 </div>
							</div>
						</div>
					</div>
					<!-- <div class="block-item block-item-class">
                <span class="label">上下边距</span>
                <div class="item-slider">
                  <el-slider
                    style="width: 160px"
                    v-model="curItem.style.paddingTop"
                    :min="0"
                    :max="50"
                  />
                  <span class="unit-text">
                    <span>{{ curItem.style.paddingTop }}</span>
                    <span>像素</span>
                  </span>
                </div>
              </div> -->

					<div class="block-item block-item-class">
						<span class="label">上下边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingTop" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingTop')"
							v-model="curItem.style.paddingTop" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">左右边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingLeft" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingLeft')"
							v-model="curItem.style.paddingLeft" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">圆角</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.radiusTop" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'radiusTop')" v-model="curItem.style.radiusTop"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<!-- <div class="block-item block-item-class">
					<span class="label">下圆角</span>
					<div class="item-slider">
					  <el-slider  style="width: 100%" v-model="curItem.style.radiusLeft" :min="0" :max="50" />
					</div>
								<el-input type="number" @input="e=>changeInput(e,'radiusLeft')" v-model="curItem.style.radiusLeft" size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入" >
								  <span slot="suffix" class="input_text" style="">PX</span>
								</el-input>
				</div>	 -->
				</div>
				<!-- </el-tab-pane>
        </el-tabs> -->
			</div>

			<!-- 文章组 -->
			<div v-if="curItem.type == 'article'" class="editor-content editor-content-banner">
				<div class="block-box">
					<div class="block-title">文章内容</div>
					<div class="block-item block-item-class">
						<span class="label">文章分类</span>
						<SArticleCate v-model="curItem.params.auto.category" />
					</div>
					<div class="block-item block-item-class">
						<span class="label">显示数量</span>
						<div class="block-item-right flex_c_s">
							<el-input size="small" class="flex1" v-model="curItem.params.auto.showNum" :min="1"
								:max="20" />
							<span class="unit-text">
								<span>篇</span>
							</span>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">圆角</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.radius" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'radius')" v-model="curItem.style.radius"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">上边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingY" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingY')" v-model="curItem.style.paddingY"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">下边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingY1" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingY1')" v-model="curItem.style.paddingY1"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">左边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingX" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingX')" v-model="curItem.style.paddingX"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">右边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingX1" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingX1')" v-model="curItem.style.paddingX1"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">组件背景</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.zubackground"
									defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.zubackground" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
						onEditorResetColor(curItem.style, 'zubackground', '#fff')
					  "> 重置 </div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- 在线客服 -->
			<div v-if="curItem.type == 'service'" class="editor-content editor-content-banner">
				<!-- <el-tabs>
          <el-tab-pane key="1" label="内容设置"> -->
				<div class="block-box">
					<!-- <div class="block-title">功能设置</div> -->
					<div class="block-item block-item-class">
						<span class="label">客服类型</span>
						<el-radio-group v-model="curItem.params.type" type="button">
							<el-radio label="chat">在线聊天</el-radio>
							<el-radio label="phone">拨打电话</el-radio>
						</el-radio-group>
					</div>
					<div v-show="curItem.params.type == 'phone'" class="block-item" style="margin-bottom: 10px;">
						<span class="label">电话号码</span>
						<el-input size="small" v-model="curItem.params.tel" />
					</div>
					<div class="block-item">
						<span class="label">客服图标</span>
						<span class="tips-wrap">建议尺寸90×90</span>
						<SImage v-model="curItem.params.image" :width="60" :height="60" />
					</div>
				</div>
				<!-- </el-tab-pane>
          <el-tab-pane key="2" label="样式设置"> -->
				<div class="block-box">
					<!-- <div class="block-title">组件样式</div> -->
					<div class="block-item block-item-class">
						<span class="label">宽度</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.width" :min="0" :max="150" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'width')" v-model="curItem.style.width"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">高度</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.height" :min="0" :max="150" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'height')" v-model="curItem.style.height"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<!-- <div class="block-item block-item-class">
				<span class="label">宽度</span>
				<div class="item-slider">
				  <el-slider
					style="width: 160px"
					v-model="curItem.style.width"
					:min="0"
					:max="150"
				  />
				  <span class="unit-text">
					<span>{{ curItem.style.width }}</span>
					<span>像素</span>
				  </span>
				</div>
			  </div> -->
					<!-- <div class="block-item block-item-class">
				<span class="label">高度</span>
				<div class="item-slider">
				  <el-slider
					style="width: 160px"
					v-model="curItem.style.height"
					:min="0"
					:max="150"
				  />
				  <span class="unit-text">
					<span>{{ curItem.style.height }}</span>
					<span>像素</span>
				  </span>
				</div>
			  </div> -->
					<div class="block-item block-item-class">
						<span class="label">底边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.bottom" :min="0" :max="150" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'bottom')" v-model="curItem.style.bottom"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">右边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.right" :min="0" :max="200" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'right')" v-model="curItem.style.right"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">不透明度</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.opacity" :min="0" :max="100" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'right')" v-model="curItem.style.opacity"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">%</span>
						</el-input>
					</div>
					<!-- <div class="block-item block-item-class">
                <span class="label">不透明度</span>
                <div class="item-slider">
                  <el-slider
                    style="width: 160px"
                    v-model="curItem.style.opacity"
                    :min="0"
                    :max="100"
                  />
                  <span class="unit-text">
                    <span>{{ curItem.style.opacity }}</span>
                    <span>%</span>
                  </span>
                </div>
              </div> -->
				</div>
				<!-- </el-tab-pane>
        </el-tabs> -->
			</div>

			<!-- 视频组 -->
			<div v-if="curItem.type == 'video'" class="editor-content editor-content-banner">
				<!-- <el-tabs>
          <el-tab-pane key="1" label="内容设置"> -->
				<div class="block-box">
					<!-- <div class="block-title">功能设置</div> -->
					<!-- <div class="block-item has-tips block-item-class">
                <span class="label">视频地址</span>
                <div class="flex-box">
                  <el-input size="small" v-model="curItem.params.videoUrl" />
                  <div class="tips">仅支持.mp4格式的视频源地址</div>
                </div>
              </div> -->
					<div class="block-item has-tips block-item-class">
						<span class="label">上传视频</span>
						<div class="flex-box">
							<div v-if="curItem.params.videoUrl">
								<video width="142" height="80" controls>
									<source :src="curItem.params.videoUrl" type="video/mp4"
										style="position: absolute" />
								</video>
								<i class="el-icon-error video_delicon" @click="handvideOff"></i>
							</div>

							<div class="goodsimage" style="
                      position: relative;
                      overflow: hidden;
                      width: 142px;
                      height: 80px;
                    " v-else>
								<input style="
                        position: absolute;
                        z-index: 999;
                        width: 100%;
                        height: 100%;
                        opacity: 0;
                      " ref="fileInput" accept=".mp4" type="file" @change="uploadFun" />
								<div class="imgbox">
									<i class="el-icon-plus addicon"></i>
									<div class="text">添加视频</div>
								</div>
							</div>
							<!-- <el-input size="small" v-model="curItem.params.videoUrl" /> -->
							<div class="tips">仅支持.mp4格式的视频，宽度为750px</div>
						</div>
					</div>
					<div class="block-item has-tips block-item-class">
						<span class="label">视频封面</span>
						<div class="flex-box">
							<SImage v-model="curItem.params.poster" :width="142" :height="80" />
							<div class="tips">
								建议图片大小为800x450，上传16:9尺寸的图片
							</div>
						</div>
					</div>
				</div>
				<div class="block-box">
					<!-- <div class="block-title">播放设置</div> -->
					<div class="block-item has-tips block-item-class">
						<span class="label">自动播放</span>
						<div class="flex-box">
							<el-radio-group v-model="curItem.params.autoplay" type="button">
								<el-radio :label="1">开启</el-radio>
								<el-radio :label="0">关闭</el-radio>
							</el-radio-group>
							<!-- <span class="tips" >仅支持微信小程序</span> -->
						</div>
					</div>
				</div>
				<!-- </el-tab-pane>
          <el-tab-pane key="2" label="样式设置"> -->
				<!-- <div class="block-box">
					
				</div> -->
				<div class="block-box">
					<!-- <div class="block-title">组件样式</div> -->
					<div class="block-item block-item-class">
						<span class="label">组件背景</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.zubackground"
									defaultColor="#000" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.zubackground" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
			            onEditorResetColor(curItem.style, 'zubackground', '#f9f9f9')
			          ">
									重置
								</div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">视频高度</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.height" :min="50" :max="400" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'height')" v-model="curItem.style.height"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">上下边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingTop" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingTop')"
							v-model="curItem.style.paddingTop" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">左右边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingLeft" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingLeft')"
							v-model="curItem.style.paddingLeft" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">视频圆角</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.borderRadius" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'borderRadius')"
							v-model="curItem.style.borderRadius" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<!-- <div class="block-item">
                <span class="label">上下边距</span>
                <div class="item-slider">
                  <el-slider
                    style="width: 160px"
                    v-model="curItem.style.paddingTop"
                    :min="0"
                    :max="50"
                  />
                  <span class="unit-text">
                    <span>{{ curItem.style.paddingTop }}</span>
                    <span>像素</span>
                  </span>
                </div>
              </div> -->
				</div>

				<!-- </el-tab-pane>
        </el-tabs> -->
			</div>
			<!-- 限时秒杀 -->
			<div v-if="curItem.type == 'seckill'" class="editor-content editor-content-banner">
				<div class="block-box">
					<div class="block-item has-tips block-item-class">
						<span class="label">标题图片</span>
						<div class="flex-box">
							<SImage v-model="curItem.params.title" :width="100" :height="22" />
							<div class="tips">
								建议图片大小为100x22尺寸的图片
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">更多文字</span>
						<div class="block-item-right flex_c_s">
							<el-input size="small" class="flex1" v-model="curItem.params.text" />
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">选择活动</span>
						<SMarks @getValue="activeSeckill" :typelei="0" />
					</div>
					<div class="block-item block-item-class">
						<span class="label">上边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingTop" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingTop')"
							v-model="curItem.style.paddingTop" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">下边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingBottom" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingBottom')"
							v-model="curItem.style.paddingBottom" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">左边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingLeft" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingLeft')"
							v-model="curItem.style.paddingLeft" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">右边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingRight" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingRight')"
							v-model="curItem.style.paddingRight" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">圆角尺寸</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.borderRadius" :min="0" :max="50" />
							<!-- <span class="unit-text">
			      <span>{{ curItem.style.borderRadius }}</span>
			      <span>像素</span>
			    </span> -->
						</div>
						<el-input type="number" @input="e=>changeInput(e,'borderRadius')"
							v-model="curItem.style.borderRadius" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">组件背景</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.zubackground"
									defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.zubackground" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
			          onEditorResetColor(curItem.style, 'zubackground', '#fff')
			        ">
									重置
								</div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">背景类型</span>
						<el-radio-group v-model="curItem.style.bgType" type="button">
							<el-radio label="color">背景颜色</el-radio>
							<el-radio label="bg">背景图片</el-radio>
						</el-radio-group>
					</div>
					<div v-if="curItem.style.bgType=='color'" class="block-item block-item-class">
						<span class="label">背景颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.background" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.background" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
			          onEditorResetColor(curItem.style, 'background', '#fff')
			        ">
									重置
								</div>
							</div>
						</div>
					</div>
					<div v-else class="block-item has-tips block-item-class">
						<span class="label">背景图片</span>
						<div class="flex-box">
							<SImage v-model="curItem.style.backgroundimg" :width="100" :height="45" />
							<div class="tips">
								建议图片大小为370x166尺寸的图片
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">文字颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.text" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.text" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
			          onEditorResetColor(curItem.style, 'text', '#1a1a1a')
			        ">
									重置
								</div>
							</div>
						</div>
					</div>

					<div class="block-item block-item-class">
						<span class="label">时间文字</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.timetext" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.timetext" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
			          onEditorResetColor(curItem.style, 'timetext', '#fff')
			        ">
									重置
								</div>
							</div>
						</div>
					</div>

					<div class="block-item block-item-class">
						<span class="label">时间背景</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.timebackground"
									defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.timebackground" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
			          onEditorResetColor(curItem.style, 'timebackground', '#FF2E38')
			        ">
									重置
								</div>
							</div>
						</div>
					</div>

				</div>

			</div>

			<!-- 超值单品 -->
			<div v-if="curItem.type == 'super'" class="editor-content editor-content-banner">
				<div class="block-box">
					<div class="block-item has-tips block-item-class">
						<span class="label">标题图片</span>
						<div class="flex-box">
							<SImage v-model="curItem.params.title" :width="100" :height="22" />
							<div class="tips">
								建议图片大小为100x22尺寸的图片
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">更多文字</span>
						<div class="block-item-right flex_c_s">
							<el-input size="small" class="flex1" v-model="curItem.params.text" />
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">选择活动</span>
						<SMarksup @getValue="activeSeckill" :typelei="1" />
					</div>

					<div class="block-item block-item-class">
						<span class="label">上边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingTop" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingTop')"
							v-model="curItem.style.paddingTop" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">下边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingBottom" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingBottom')"
							v-model="curItem.style.paddingBottom" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">左边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingLeft" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingLeft')"
							v-model="curItem.style.paddingLeft" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">右边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingRight" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingRight')"
							v-model="curItem.style.paddingRight" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">圆角尺寸</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.borderRadius" :min="0" :max="50" />
							<!-- <span class="unit-text">
	  			      <span>{{ curItem.style.borderRadius }}</span>
	  			      <span>像素</span>
	  			    </span> -->
						</div>
						<el-input type="number" @input="e=>changeInput(e,'borderRadius')"
							v-model="curItem.style.borderRadius" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">组件背景</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.zubackground"
									defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.zubackground" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
				          onEditorResetColor(curItem.style, 'zubackground', '#fff')
				        ">
									重置
								</div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">背景类型</span>
						<el-radio-group v-model="curItem.style.bgType" type="button">
							<el-radio label="color">背景颜色</el-radio>
							<el-radio label="bg">背景图片</el-radio>
						</el-radio-group>
					</div>
					<div v-if="curItem.style.bgType=='color'" class="block-item block-item-class">
						<span class="label">背景颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.background" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.background" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
	  			          onEditorResetColor(curItem.style, 'background', '#fff')
	  			        ">
									重置
								</div>
							</div>
						</div>
					</div>
					<div v-else class="block-item has-tips block-item-class">
						<span class="label">背景图片</span>
						<div class="flex-box">
							<SImage v-model="curItem.style.backgroundimg" :width="100" :height="45" />
							<div class="tips">
								建议图片大小为370x166尺寸的图片
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">文字颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.text" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.text" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
	  			          onEditorResetColor(curItem.style, 'text', '#1a1a1a')
	  			        ">
									重置
								</div>
							</div>
						</div>
					</div>

				</div>

			</div>

			<!-- 付费券包 -->
			<div v-if="curItem.type == 'couponpack'" class="editor-content editor-content-banner">
				<div class="block-box" style="margin-bottom: 35px;">
					<div class="block-title" style="margin-bottom: 15px;">
						选择券包 ({{ curItem.data.length }})
					</div>
					<SCouponpack v-model="curItem.data" :maxNum="15" />
				</div>
				<div class="block-box">
					<!-- <div class="block-item block-item-class">
				  <span class="label">选择券包</span>
				  <SCouponpack @getValue="activeCouponpack"  />
				</div> -->
					
					<div class="block-item block-item-class">
						<span class="label">组件背景</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.zubackground"
									defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.zubackground" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
				          onEditorResetColor(curItem.style, 'zubackground', '#fff')
				        ">
									重置
								</div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">背景类型</span>
						<el-radio-group v-model="curItem.style.bgType" type="button">
							<el-radio label="color">背景颜色</el-radio>
							<el-radio label="bg">背景图片</el-radio>
						</el-radio-group>
					</div>
					<div v-if="curItem.style.bgType=='color'" class="block-item block-item-class">
						<span class="label">背景颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.background" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.background" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
				          onEditorResetColor(curItem.style, 'background', '#fff')
				        ">
									重置
								</div>
							</div>
						</div>
					</div>
					<div v-else class="block-item has-tips block-item-class">
						<span class="label">背景图片</span>
						<div class="flex-box">
							<SImage v-model="curItem.style.backgroundimg" :width="100" :height="45" />
							<div class="tips">
								建议图片大小为370x166尺寸的图片
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">营销标题</span>
						<div class="block-item-right flex_c_s">
							<el-input size="small" class="flex1" v-model="curItem.params.text" />
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">上边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingTop" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingTop')"
							v-model="curItem.style.paddingTop" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">下边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingBottom" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingBottom')"
							v-model="curItem.style.paddingBottom" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">左边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingLeft" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingLeft')"
							v-model="curItem.style.paddingLeft" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">右边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingRight" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingRight')"
							v-model="curItem.style.paddingRight" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">圆角尺寸</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.borderRadius" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'borderRadius')"
							v-model="curItem.style.borderRadius" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<!-- <div class="block-item block-item-class">
				  <span class="label">时间背景</span>
				  <div class="item-colorPicker">
				    <div class="color-picker-box">
				      <el-color-picker
				        size="small"
				        v-model="curItem.style.timebg"
				        defaultColor="#fff"
				      />
				    </div>
				    <div class="reset-color">
				      <div class="ipt">
				        <SInput v-model="curItem.style.timebg" width="100px" height="32px" border-radius="2px 0 0 2px" highlight-color="#006aff" ></SInput>
				      </div>
				      <div class="color-txt" @click=" onEditorResetColor(curItem.style, 'timebg', '#fff') " > 重置 </div>
				    </div>
				  </div>
				</div> -->
					<div class="block-item block-item-class">
						<span class="label">更多颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.timecolor" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.timecolor" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt"
									@click=" onEditorResetColor(curItem.style, 'timecolor', '#fff') "> 重置 </div>
							</div>
						</div>
					</div>
					<!-- {{curItem}} -->
					<div class="block-item block-item-class">
						<span class="label">样式模板</span>
						<el-radio-group v-model="curItem.style.model" type="button">
							<el-radio label="model1">模板1</el-radio>
							<el-radio label="model2" >模板2</el-radio>
							<el-radio label="model3" >模板3</el-radio>
						</el-radio-group>
					</div>
					<div style=" ">
						<div class="block-item block-item-class">
							<span class="label">背景颜色</span>
							<div class="item-colorPicker">
								<div class="color-picker-box">
									<el-color-picker size="small" v-model="curItem.style.model1_bg"
										defaultColor="#fff" />
								</div>
								<div class="reset-color">
									<div class="ipt">
										<SInput v-model="curItem.style.model1_bg" width="100px" height="32px"
											border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
									</div>
									<div class="color-txt"
										@click=" onEditorResetColor(curItem.style, 'model1_bg', '#fff') "> 重置 </div>
								</div>
							</div>
						</div>
						<div class="block-item block-item-class">
							<span class="label">圆角尺寸</span>
							<div class="item-slider">
								<el-slider style="width: 100%" v-model="curItem.style.model1_borderRadius" :min="0"
									:max="50" />
							</div>
							<el-input type="number" @input="e=>changeInput(e,'model1_borderRadius')"
								v-model="curItem.style.model1_borderRadius" size="mini"
								style="width: 150px;margin-left: 10px;" placeholder="请输入">
								<span slot="suffix" class="input_text" style="">PX</span>
							</el-input>
						</div>
						<div class="block-item block-item-class" v-show="curItem.style.model != 'model2'">
							<span class="label">上下距离</span>
							<div class="item-slider">
								<el-slider style="width: 100%" v-model="curItem.style.model1_paddingTop" :min="0"
									:max="50" />
							</div>
							<el-input type="number" @input="e=>changeInput(e,'model1_paddingTop')"
								v-model="curItem.style.model1_paddingTop" size="mini"
								style="width: 150px;margin-left: 10px;" placeholder="请输入">
								<span slot="suffix" class="input_text" style="">PX</span>
							</el-input>
						</div>
						<div class="block-item block-item-class" v-show="curItem.style.model != 'model2'">
							<span class="label">左右距离</span>
							<div class="item-slider">
								<el-slider style="width: 100%" v-model="curItem.style.model1_paddingLeft" :min="0"
									:max="50" />
							</div>
							<el-input type="number" @input="e=>changeInput(e,'model1_paddingLeft')"
								v-model="curItem.style.model1_paddingLeft" size="mini"
								style="width: 150px;margin-left: 10px;" placeholder="请输入">
								<span slot="suffix" class="input_text" style="">PX</span>
							</el-input>
						</div>
						<div class="block-item block-item-class">
							<span class="label">商品背景</span>
							<div class="item-colorPicker">
								<div class="color-picker-box">
									<el-color-picker size="small" v-model="curItem.style.model1_goodbg"
										defaultColor="#fff" />
								</div>
								<div class="reset-color">
									<div class="ipt">
										<SInput v-model="curItem.style.model1_goodbg" width="100px" height="32px"
											border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
									</div>
									<div class="color-txt"
										@click=" onEditorResetColor(curItem.style, 'model1_goodbg', '#fff') "> 重置 </div>
								</div>
							</div>
						</div>
						<div class="block-item block-item-class">
							<span class="label">标题颜色</span>
							<div class="item-colorPicker">
								<div class="color-picker-box">
									<el-color-picker size="small" v-model="curItem.style.model1_goodtcolor"
										defaultColor="#fff" />
								</div>
								<div class="reset-color">
									<div class="ipt">
										<SInput v-model="curItem.style.model1_goodtcolor" width="100px" height="32px"
											border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
									</div>
									<div class="color-txt"
										@click=" onEditorResetColor(curItem.style, 'model1_goodtcolor', '#fff') "> 重置
									</div>
								</div>
							</div>
						</div>
						<div class="block-item block-item-class">
							<span class="label">价格颜色</span>
							<div class="item-colorPicker">
								<div class="color-picker-box">
									<el-color-picker size="small" v-model="curItem.style.model1_goodncolor"
										defaultColor="#fff" />
								</div>
								<div class="reset-color">
									<div class="ipt">
										<SInput v-model="curItem.style.model1_goodncolor" width="100px" height="32px"
											border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
									</div>
									<div class="color-txt"
										@click=" onEditorResetColor(curItem.style, 'model1_goodncolor', '#fff') "> 重置
									</div>
								</div>
							</div>
						</div>
						<div class="block-item block-item-class">
							<span class="label">划线价格</span>
							<div class="item-colorPicker">
								<div class="color-picker-box">
									<el-color-picker size="small" v-model="curItem.style.model1_goodocolor"
										defaultColor="#fff" />
								</div>
								<div class="reset-color">
									<div class="ipt">
										<SInput v-model="curItem.style.model1_goodocolor" width="100px" height="32px"
											border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
									</div>
									<div class="color-txt"
										@click=" onEditorResetColor(curItem.style, 'model1_goodocolor', '#fff') "> 重置
									</div>
								</div>
							</div>
						</div>
						<div class="block-item block-item-class">
							<span class="label">按钮文字</span>
							<div class="item-colorPicker">
								<div class="color-picker-box">
									<el-color-picker size="small" v-model="curItem.style.model1_goodbutcolor"
										defaultColor="#fff" />
								</div>
								<div class="reset-color">
									<div class="ipt">
										<SInput v-model="curItem.style.model1_goodbutcolor" width="100px" height="32px"
											border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
									</div>
									<div class="color-txt"
										@click=" onEditorResetColor(curItem.style, 'model1_goodbutcolor', '#fff') "> 重置
									</div>
								</div>
							</div>
						</div>
						<div class="block-item block-item-class">
							<span class="label">按钮背景</span>
							<div class="item-colorPicker">
								<div class="color-picker-box">
									<el-color-picker size="small" v-model="curItem.style.model1_goodbutbg"
										defaultColor="#fff" />
								</div>
								<div class="reset-color">
									<div class="ipt">
										<SInput v-model="curItem.style.model1_goodbutbg" width="100px" height="32px"
											border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
									</div>
									<div class="color-txt"
										@click=" onEditorResetColor(curItem.style, 'model1_goodbutbg', '#fff') "> 重置
									</div>
								</div>
							</div>
						</div>

					</div>
				</div>

			</div>


			<div v-if="curItem.type == 'live'" class="editor-content editor-content-banner">
				<div class="block-box" style="margin-bottom: 35px;">
					<div class="block-title">
						选择直播间 ({{ curItem.data.length }})
					</div>
					<SLive1 v-model="curItem.data" />
				</div>
				<div class="block-box">
					<!-- <div class="block-title">样式设置</div> -->
					<div class="block-item block-item-class">
						<span class="label">组件背景</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.zubackground"
									defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.zubackground" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#fff"></SInput>
								</div>
								<div class="color-txt" @click="
								onEditorResetColor(curItem.style, 'zubackground', '#fff')
							  ">
									重置
								</div>
							</div>
						</div>

					</div>
					<div class="block-item block-item-class">
						<span class="label">内容样式</span>
						<!-- <span class="tips-wrap">仅支持小程序</span> -->
						<el-radio-group v-model="curItem.params.type" type="button">
							<el-radio :label="1">样式一</el-radio>
							<el-radio :label="2">样式二</el-radio>
						</el-radio-group>
					</div>
					<div class="block-item block-item-class">
						<span class="label">上边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingTop" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingTop')"
							v-model="curItem.style.paddingTop" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">下边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingBottom" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingBottom')"
							v-model="curItem.style.paddingBottom" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">左边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingLeft" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingLeft')"
							v-model="curItem.style.paddingLeft" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">右边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingRight" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingRight')"
							v-model="curItem.style.paddingRight" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">圆角尺寸</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.borderRadius" :min="0" :max="50" />
							<!-- <span class="unit-text">
	  	  			      <span>{{ curItem.style.borderRadius }}</span>
	  	  			      <span>像素</span>
	  	  			    </span> -->
						</div>
						<el-input type="number" @input="e=>changeInput(e,'borderRadius')"
							v-model="curItem.style.borderRadius" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
				</div>

			</div>

			<!-- 图片组 -->
			<div v-if="curItem.type == 'image'" class="editor-content editor-content-banner">
				<!-- <el-tabs>
          <el-tab-pane key="1" label="内容设置"> -->
				<div class="sub-title">添加图片 (最多10张，可拖动排序）</div>
				<draggable :list="curItem.data" v-bind="{
                animation: 120,
                filter: 'input',
                preventOnFilter: false,
              }">
					<div v-for="(item, index) in curItem.data" :key="index" class="block-box drag drage-banner">
						<div class="block-title">
							<!-- <span class="left">图片 {{ index + 1 }}</span> -->
							<a class="link" @click="handleDeleleData(curItem, index)"><i class="el-icon-error"></i></a>
						</div>
						<div class="block-item">
							<img src="@/assets/icon/icon-move.png" alt="" style="width: 20px; height: 20px" />
							<div class="block-item-custom">
								<SImage width="70px" height="70px" v-model="item.imgUrl" tips="建议尺寸宽750"
									@update="item.imgName = $event.file_name" />
							</div>
							<div class="block-item-common">
								<!-- <div class="block-item-common-row">
									<span class="label">图片名称</span>
									<span class="label value">{{ item.imgName }}</span>
								</div> -->
								<div class="block-item-common-row">
									<!-- <span class="label">链接</span> -->
									<SLink v-model="item.link" />
								</div>
								<span>建议图片宽度750px</span>
							</div>
						</div>
					</div>
				</draggable>
				<div v-if="curItem.data.length < 10" class="data-add">
					<el-button icon="plus" @click="handleAddData(10)">添加图片</el-button>
				</div>
				<!-- </el-tab-pane>
          <el-tab-pane key="2" label="样式设置"> -->
				<div class="block-box">
					<!-- <div class="block-title">组件样式</div> -->
					<div class="block-item block-item-class">
						<span class="label">上下边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingTop" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingTop')"
							v-model="curItem.style.paddingTop" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">左右边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingLeft" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingLeft')"
							v-model="curItem.style.paddingLeft" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">圆角尺寸</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.borderRadius" :min="0" :max="20" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'borderRadius')"
							v-model="curItem.style.borderRadius" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">背景颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.background" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.background" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
                        onEditorResetColor(curItem.style, 'background', '#fff')
                      ">
									重置
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- </el-tab-pane>
        </el-tabs> -->
			</div>

			<!-- 轮播图 -->
			<div v-if="curItem.type == 'banner'" class="editor-content editor-content-banner">
				<!-- <el-tabs>
          <el-tab-pane key="1" label="内容设置"> -->
				<div class="sub-title">添加图片 (最多10张，可拖动排序）</div>
				<draggable :list="curItem.data" v-bind="{
                animation: 120,
                filter: 'input',
                preventOnFilter: false,
              }">
					<div v-for="(item, index) in curItem.data" :key="index" class="block-box drag drage-banner">
						<div class="block-title">
							<a class="link" @click="handleDeleleData(curItem, index)">
								<i class="el-icon-error"></i></a>
						</div>
						<div class="block-item">
							<img src="@/assets/icon/icon-move.png" alt="" style="width: 20px; height: 20px" />
							<div class="block-item-custom">
								<SImage width="70px" height="70px" v-model="item.imgUrl" tips="建议尺寸750×400"
									@update="item.imgName = $event.filename" />
							</div>
							<div class="block-item-common">
								<div class="block-item-common-row">
									<SLink v-model="item.link" />
								</div>
								<span>建议图片宽度750px，高度跟随第一张图片的高度变化</span>
							</div>
						</div>
					</div>
				</draggable>
				<div v-if="curItem.data.length < 10" class="data-add">
					<el-button icon="plus" @click="handleAddData(10)">添加图片</el-button>
				</div>
				<!-- </el-tab-pane>
          <el-tab-pane key="2" label="样式设置"> -->
				<div class="block-box" >
					<!-- <div class="block-title">内容样式</div> -->
					<div class="block-item block-item-class">
						<span class="label">指示点状态</span>
						<el-radio-group v-model="curItem.params.dot" type="button">
							<el-radio :label="1">显示</el-radio>
							<el-radio :label="2">隐藏</el-radio>
						</el-radio-group>
					</div>
					<div v-if='curItem.params.dot==1' class="block-item block-item-class">
						<span class="label">指示点形状</span>
						<el-radio-group v-model="curItem.style.btnShape" type="button">
							<el-radio label="round">圆形</el-radio>
							<!-- <el-radio label="square">正方形</el-radio>
                  <el-radio label="rectangle">长方形</el-radio> -->
							<el-radio label="num">数量</el-radio>
						</el-radio-group>
					</div>
					<div v-if='curItem.params.dot==1' class="block-item block-item-class">
						<span class="label">指示点颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.btnColor" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.btnColor" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
                        onEditorResetColor(curItem.style, 'btnColor', '#fff')
                      ">
									重置
								</div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">组件背景</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.background" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.background" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#fff"></SInput>
								</div>
								<div class="color-txt" @click=" onEditorResetColor(curItem.style, 'background', '#fff') ">
									重置
								</div>
							</div>
						</div>

					</div>
					<div class="block-item block-item-class">
						<span class="label">切换时间</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.interval" :step="1" :min="1"
								:max="20" />
							<!-- <span class="unit-text">
								<span>{{ curItem.style.interval }}</span>
								<span>秒</span>
							</span> -->
						</div>
						<el-input type="number" @input="e=>changeInput(e,'interval')" v-model="curItem.style.interval"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">秒</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">上边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingY" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingY')" v-model="curItem.style.paddingY"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">下边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingY1" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingY1')" v-model="curItem.style.paddingY1"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">左边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingX" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingX')" v-model="curItem.style.paddingX"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">右边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingX1" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingX1')" v-model="curItem.style.paddingX1"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<!-- <div class="block-item block-item-class">
                <span class="label">上下边距</span>
                <div class="item-slider">
                  <el-slider
                    style="width: 160px"
                    v-model="curItem.style.paddingY"
                    :min="0"
                    :max="30"
                  />
                  <span class="unit-text">
                    <span>{{ curItem.style.paddingY }}</span>
                    <span>像素</span>
                  </span>
                </div>
              </div> -->
					<!-- <div class="block-item block-item-class">
                <span class="label">左右边距</span>
                <div class="item-slider">
                  <el-slider
                    style="width: 160px"
                    v-model="curItem.style.paddingX"
                    :min="0"
                    :max="20"
                  />
                  <span class="unit-text">
                    <span>{{ curItem.style.paddingX }}</span>
                    <span>像素</span>
                  </span>
                </div>
              </div> -->
					<div class="block-item block-item-class">
						<span class="label">圆角尺寸</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.borderRadius" :min="0" :max="20" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'borderRadius')"
							v-model="curItem.style.borderRadius" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<!-- <div class="block-item block-item-class">
                <span class="label">圆角尺寸</span>
                <div class="item-slider">
                  <el-slider
                    style="width: 160px"
                    v-model="curItem.style.borderRadius"
                    :min="0"
                    :max="20"
                  />
                  <span class="unit-text">
                    <span>{{ curItem.style.borderRadius }}</span>
                    <span>像素</span>
                  </span>
                </div>
              </div> -->
				</div>
				<!-- </el-tab-pane>
        </el-tabs> -->
			</div>
			<!-- 商品组 -->
			<div v-if="curItem.type == 'tabgoods'" class="tabgoods_box editor-content editor-content-banner">
				<el-tabs type="border-card" v-model="curItem.params.tabVals" editable @edit="handleTabsEdit">
					<el-tab-pane :key="item.index" v-for="(item, index) in curItem.params.tab" :label="item.title"
						:name="item.index">
						
						<div class="block-box">
							<div class="block-item block-item-class">
							  <span class="label">主标题</span>
							  <div class="flex-box">
							    <el-input size="small" v-model="item.title" />
							    <!-- <div class="tips">主标题</div> -->
							  </div>
							</div>
						</div>
						<div class="block-box">
							<div class="block-item block-item-class">
							  <span class="label">副标题</span>
							  <div class="flex-box">
							    <el-input size="small" v-model="item.sub" />
							    <!-- <div class="tips">主标题</div> -->
							  </div>
							</div>
						</div>
						<div class="block-box">
							<div class="block-item block-item-class">
								<span class="label">商品来源</span>
								<el-radio-group size="small" @change="goodChange" v-model="item.source" type="button">
									<el-radio label="auto">自动获取</el-radio>
									<el-radio label="choice">手动选择</el-radio>
									<el-radio label="category">选择分类</el-radio>
								</el-radio-group>
							</div>
						</div>
						<!-- 手动选择 -->
						<div v-if="item.source === 'choice'" class="block-box" style="margin-bottom: 25px;">
							<div class="block-title" style="margin-bottom:0">
								选择商品 ({{ item.goods.length }}/50)
							</div>
							<small style="color:#888">最多可选择50个商品，超出将截取前50个商品</small>
							<SGoods :maxNum="50" v-model="item.goods" />
						</div>
						<div v-if="item.source === 'category'" class="block-box">
							<div class="block-item block-item-class">
								<span class="label">商品分类</span>
								<SGoodsCate :vals="item.auto.category" @getValue="getValue" style="width: 270px">
								</SGoodsCate>
							</div>
							<div class="block-item block-item-class">
								<span class="label">显示数量</span>
								<div class="item-slider ">
									<el-slider style="width: 100%" v-model="item.auto.showNum" :min="0" :max="50" />
								</div>
								<el-input type="number" @input="e=>changeGoods(e,'showNum')" v-model="item.auto.showNum"
									size="mini" style="width: 130px;margin-left: 10px;" placeholder="请输入">
									<span slot="suffix" class="input_text" style="">件</span>
								</el-input>
							</div>
						</div>
						<!-- 自动获取 -->
						<div v-if="item.source === 'auto'" class="block-box">
							<div class="block-item block-item-class">
								<span class="label">商品排序</span>
								<el-radio-group v-model="item.auto.goodsSort" type="button">
									<el-radio label="all">默认</el-radio>
									<el-radio label="sales">销量</el-radio>
									<el-radio label="price">价格</el-radio>
								</el-radio-group>
							</div>
							<div class="block-item block-item-class">
								<span class="label">显示数量</span>
								<div class="item-slider ">
									<el-slider style="width: 100%" v-model="item.auto.showNum" :min="1" :max="50" />
								</div>
								<el-input type="number" @input="e=>changeGoods(e,'showNum')" v-model="item.auto.showNum"
									size="mini" style="width: 130px;margin-left: 10px;" placeholder="请输入">
									<span slot="suffix" class="input_text" style="">件</span>
								</el-input>

							</div>
						</div>
					</el-tab-pane>
				</el-tabs>
				
				<div style="width:100%; margin-bottom: 20px;border-top:1px solid #ededed;padding-top: 20px; ">
					<span style="font-size: 16px;font-weight: bold;padding-left:10px;color:#000">内容设置</span>
				</div>
				<!-- <div class="data-add">
					<el-button icon="plus" @click="handleTabsEdit(10)">添加标签</el-button>
				</div> -->
				
				<div class="block-box">
					<!-- <div class="block-title">商品样式</div> -->
					<div class="block-item block-item-class">
						<span class="label">主题颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.tabColor"
									defaultColor="#FF0000" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.tabColor" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt"
									@click=" onEditorResetColor( curItem.style, 'tabColor', '#27c29a' ) "> 重置
								</div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">内容样式</span>
						<el-radio-group v-model="curItem.style.cardType" type="button">
							<el-radio label="flat">扁平</el-radio>
							<el-radio label="card">卡片</el-radio>
						</el-radio-group>
					</div>
					<div class="block-item block-item-class">
						<span class="label">显示类型</span>
						<el-radio-group v-model="curItem.style.display" type="button">
							<el-radio label="list">两列平铺</el-radio>
							<el-radio :disabled="curItem.style.column === 1" label="slide">横向滑动</el-radio>
						</el-radio-group>
					</div>
					<div class="block-item block-item-class">
						<span class="label">分列数量</span>
						<el-radio-group v-model="curItem.style.column" type="button">
							<el-radio :disabled="curItem.style.display !== 'list'" :label="1">单列</el-radio>
							<el-radio :label="2">两列</el-radio>
							<el-radio :label="3">三列</el-radio>
						</el-radio-group>
					</div>
					<div class="block-item block-item-class">
						<span class="label">商品名称</span>
						
						<div class="" style="display:flex">
							<div @click="checkR(curItem.style.show,'goodsName',true)" class="s_r">
								<span v-if="radioF(curItem.style.show,'goodsName')" class="s_radio_y">
									<span class="s_radio_active"></span>
								</span>
								<span v-else class="s_radio">
								</span>
								<span style="margin-left: 3px;font-size:14px;">显示</span>
							</div>
							<div @click="checkR(curItem.style.show,'goodsName',false)" class="s_r">
								<span v-if="!radioF(curItem.style.show,'goodsName')" class="s_radio_y">
									<span class="s_radio_active"></span>
								</span>
								<span v-else class="s_radio">
								</span>
								<span style="margin-left: 3px;font-size:14px;">不显示</span>
							</div>
						</div>
					</div>
					<div v-if="radioF(curItem.style.show,'goodsName')" class="block-item block-item-class">
						<span class="label">商品名称</span>
						<el-radio-group v-model="curItem.style.goodsWeight" type="button">
							<el-radio label="normal">不加粗</el-radio>
							<el-radio label="bold">加粗</el-radio>
						</el-radio-group>
					</div>
					<div v-if="radioF(curItem.style.show,'goodsName')" class="block-item block-item-class">
						<span class="label">名称字号</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.goodsSize" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'goodsSize')" v-model="curItem.style.goodsSize"
							size="mini" style="width: 130px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div v-if="radioF(curItem.style.show,'goodsName')" class="block-item block-item-class">
						<span class="label">商品行数</span>
						<el-radio-group v-model="curItem.style.goodsNameRows" type="button">
							<el-radio label="one">单行</el-radio>
							<el-radio label="two">双行</el-radio>
						</el-radio-group>
					</div>
					<div class="block-item block-item-class">
						<span class="label">商品价格</span>
						<div class="" style="display:flex">
							<div @click="checkR(curItem.style.show,'goodsPrice',true)" class="s_r">
								<span v-if="radioF(curItem.style.show,'goodsPrice')" class="s_radio_y">
									<span class="s_radio_active"></span>
								</span>
								<span v-else class="s_radio">
								</span>
								<span style="margin-left: 3px;font-size:14px;">显示</span>
							</div>
							<div @click="checkR(curItem.style.show,'goodsPrice',false)" class="s_r">
								<span v-if="!radioF(curItem.style.show,'goodsPrice')" class="s_radio_y">
									<span class="s_radio_active"></span>
								</span>
								<span v-else class="s_radio">
								</span>
								<span style="margin-left: 3px;font-size:14px;">不显示</span>
							</div>
						</div>
					</div>
					<div v-if="radioF(curItem.style.show,'goodsPrice')" class="block-item block-item-class">
						<span class="label">价格颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.priceColor" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.priceColor" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#FF0000"></SInput>
								</div>
								<div class="color-txt" @click="
					      onEditorResetColor(
					        curItem.style,
					        'priceColor',
					        '#FF0000'
					      )
					    ">
									重置
								</div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">划线价格</span>
						<div class="" style="display:flex">
							<div @click="checkR(curItem.style.show,'linePrice',true)" class="s_r">
								<span v-if="radioF(curItem.style.show,'linePrice')" class="s_radio_y">
									<span class="s_radio_active"></span>
								</span>
								<span v-else class="s_radio">
								</span>
								<span style="margin-left: 3px;font-size:14px;">显示</span>
							</div>
							<div @click="checkR(curItem.style.show,'linePrice',false)" class="s_r">
								<span v-if="!radioF(curItem.style.show,'linePrice')" class="s_radio_y">
									<span class="s_radio_active"></span>
								</span>
								<span v-else class="s_radio">
								</span>
								<span style="margin-left: 3px;font-size:14px;">不显示</span>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">会员价格</span>
						<div class="" style="display:flex">
							<div @click="checkR(curItem.style.show,'goodsGrade',true)" class="s_r">
								<span v-if="radioF(curItem.style.show,'goodsGrade')" class="s_radio_y">
									<span class="s_radio_active"></span>
								</span>
								<span v-else class="s_radio">
								</span>
								<span style="margin-left: 3px;font-size:14px;">显示</span>
							</div>
							<div @click="checkR(curItem.style.show,'goodsGrade',false)" class="s_r">
								<span v-if="!radioF(curItem.style.show,'goodsGrade')" class="s_radio_y">
									<span class="s_radio_active"></span>
								</span>
								<span v-else class="s_radio">
								</span>
								<span style="margin-left: 3px;font-size:14px;">不显示</span>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">商品卖点</span>
						<div class="" style="display:flex">
							<div @click="checkR(curItem.style.show,'sellingPoint',true)" class="s_r">
								<span v-if="radioF(curItem.style.show,'sellingPoint')" class="s_radio_y">
									<span class="s_radio_active"></span>
								</span>
								<span v-else class="s_radio">
								</span>
								<span style="margin-left: 3px;font-size:14px;">显示</span>
							</div>
							<div @click="checkR(curItem.style.show,'sellingPoint',false)" class="s_r">
								<span v-if="!radioF(curItem.style.show,'sellingPoint')" class="s_radio_y">
									<span class="s_radio_active"></span>
								</span>
								<span v-else class="s_radio">
								</span>
								<span style="margin-left: 3px;font-size:14px;">不显示</span>
							</div>
						</div>
					</div>
					<div v-if="radioF(curItem.style.show,'sellingPoint')" class="block-item block-item-class">
						<span class="label">卖点颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.sellingColor"
									defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.sellingColor" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
					      onEditorResetColor(
					        curItem.style,
					        'sellingColor',
					        '#e3771f'
					      )
					    ">
									重置
								</div>
							</div>
						</div>
					</div>
					<div v-show="curItem.style.column < 3" class="block-item block-item-class">
						<span class="label">加购按钮</span>
						<div class="" style="display:flex">
							<div @click="checkR(curItem.style.show,'cartBtn',true)" class="s_r">
								<span v-if="radioF(curItem.style.show,'cartBtn')" class="s_radio_y">
									<span class="s_radio_active"></span>
								</span>
								<span v-else class="s_radio">
								</span>
								<span style="margin-left: 3px;font-size:14px;">显示</span>
							</div>
							<div @click="checkR(curItem.style.show,'cartBtn',false)" class="s_r">
								<span v-if="!radioF(curItem.style.show,'cartBtn')" class="s_radio_y">
									<span class="s_radio_active"></span>
								</span>
								<span v-else class="s_radio">
								</span>
								<span style="margin-left: 3px;font-size:14px;">不显示</span>
							</div>
						</div>
					</div>
					<div v-if="radioF(curItem.style.show,'cartBtn')" class="tabgood_gou block-item block-item-class dancheck">
						<span class="label">购物车样式</span>
						<RadioGroup v-model="curItem.style.btnCartStyle" type="button">
							<Radio :label="1" style="padding:0 16px"><span class=" iconfont icon-jiagou1"></span></Radio>
							<Radio :label="2" style="padding:0 16px">
								<span class="card_style1"
									:style="{background:curItem.style.btnCartStyle==2?'#006aff':'#515a6e'}">
									<!-- <i class="iconfont icon-jiagou2" style="color:#fff;font-size:10px"></i> -->
									<i class="iconfont icon-jiagou3" style="color:#fff;font-size:10px"></i>
								</span>
							</Radio>
							<Radio :label="3" style="padding:0 16px"><span class=" iconfont icon-jiagou3"></span></Radio>
							<Radio :label="4" style="padding:0 16px"><span
									:style="{background:curItem.style.btnCartStyle==4?'#006aff':'#515a6e'}"
									class="card_style">购买</span></Radio>
						</RadioGroup>
					</div>
					<div v-if="radioF(curItem.style.show,'cartBtn')" class="block-item block-item-class">
						<span class="label">购物车颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.btnCartColor"
									defaultColor="#FF0000" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.btnCartColor" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt"
									@click=" onEditorResetColor( curItem.style, 'btnCartColor', '#27c29a' ) "> 重置
								</div>
							</div>
						</div>
					</div>

					<div class="block-item block-item-class">
						<span class="label">商品销量</span>
						<div class="" style="display:flex">
							<div @click="checkR(curItem.style.show,'goodsSales',true)" class="s_r">
								<span v-if="radioF(curItem.style.show,'goodsSales')" class="s_radio_y">
									<span class="s_radio_active"></span>
								</span>
								<span v-else class="s_radio">
								</span>
								<span style="margin-left: 3px;font-size:14px;">显示</span>
							</div>
							<div @click="checkR(curItem.style.show,'goodsSales',false)" class="s_r">
								<span v-if="!radioF(curItem.style.show,'goodsSales')" class="s_radio_y">
									<span class="s_radio_active"></span>
								</span>
								<span v-else class="s_radio">
								</span>
								<span style="margin-left: 3px;font-size:14px;">不显示</span>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">商品标签</span>
						<div class="" style="display:flex">
							<div @click="checkR(curItem.style.show,'goodsTag',true)" class="s_r">
								<span v-if="radioF(curItem.style.show,'goodsTag')" class="s_radio_y">
									<span class="s_radio_active"></span>
								</span>
								<span v-else class="s_radio">
								</span>
								<span style="margin-left: 3px;font-size:14px;">显示</span>
							</div>
							<div @click="checkR(curItem.style.show,'goodsTag',false)" class="s_r">
								<span v-if="!radioF(curItem.style.show,'goodsTag')" class="s_radio_y">
									<span class="s_radio_active"></span>
								</span>
								<span v-else class="s_radio">
								</span>
								<span style="margin-left: 3px;font-size:14px;">不显示</span>
							</div>
						</div>
					</div>
					
					
					<div class="block-item block-item-class">
						<span class="label">热卖标签</span>
						<el-radio-group v-model="curItem.style.hotTag" type="button">
							<el-radio label="1">显示</el-radio>
							<el-radio label="2">不显示</el-radio>
						</el-radio-group>
					</div>
					<div v-if="curItem.style.hotTag==1" class="block-item has-tips block-item-class">
						<span class="label">热卖图片</span>
						<div class="flex-box">
							<SImage v-model="curItem.style.hotImg" width="70px" height="70px" />
							<div class="tips">
								建议图片大小为110*110尺寸的图片
							</div>
						</div>
					</div>
					
					
				</div>
				<div class="block-box">
					<!-- <div class="block-title">卡片样式</div> -->
					
					<div class="block-item block-item-class">
						<span class="label">圆角尺寸</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.borderRadius" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'borderRadius')"
							v-model="curItem.style.borderRadius" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">商品间距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.itemMargin" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'itemMargin')"
							v-model="curItem.style.itemMargin" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
				</div>
				<div class="block-box">
					<!-- <div class="block-title">组件样式</div> -->
					<div class="block-item block-item-class">
						<span class="label">上边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingY" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingY')" v-model="curItem.style.paddingY"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">下边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingY1" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingY1')" v-model="curItem.style.paddingY1"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">左边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingX" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingX')" v-model="curItem.style.paddingX"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">右边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingX1" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingX1')" v-model="curItem.style.paddingX1"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">组件背景</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.background" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.background" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="  onEditorResetColor(
		                    curItem.style,
		                    'background',
		                    '#ffffff' ) "> 重置 </div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 商品组 -->
			<div v-if="curItem.type == 'goods'" class="editor-content editor-content-banner">
				<!-- <el-tabs>
          <el-tab-pane key="1" label="内容设置"> -->
				<!-- <div class="block-box">
              <div class="block-title flex_c_s block-item-class">
                <span  style="margin-right: 10px;">商品来源</span>
                <el-radio-group v-model="curItem.params.source" type="button">
                  <el-radio label="auto">自动获取</el-radio>
                  <el-radio label="choice">手动选择</el-radio>
                  <el-radio label="category">手动选择</el-radio>
                </el-radio-group>
              </div>
            </div> -->
				<div class="block-box">
					<div class="block-item block-item-class">
						<span class="label">商品来源</span>
						<el-radio-group size="small" @change="goodChange" v-model="curItem.params.source" type="button">
							<el-radio label="auto">自动获取</el-radio>
							<el-radio label="choice">手动选择</el-radio>
							<el-radio label="category">选择分类</el-radio>
						</el-radio-group>
					</div>
				</div>
				<!-- 手动选择 -->
				<div v-if="curItem.params.source === 'choice'" class="block-box" >
					<div class="block-title" style="margin-bottom:0">
						选择商品 ({{ curItem.data.length }}/50)
					</div>
					<small style="color:#888">最多可选择50个商品，超出将截取前50个商品</small>
					<SGoods :maxNum="50" v-model="curItem.data" />
				</div>
				<div v-if="curItem.params.source === 'category'" class="block-box">
					<div class="block-item block-item-class">
						<span class="label">商品分类</span>
						<SGoodsCate :vals="curItem.params.auto.category" @getValue="getValue" style="width: 270px">
						</SGoodsCate>
					</div>
					<div class="block-item block-item-class">
						<span class="label">显示数量</span>
						<div class="item-slider ">
							<el-slider style="width: 100%" v-model="curItem.params.auto.showNum" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeGoods(e,'showNum')"
							v-model="curItem.params.auto.showNum" size="mini" style="width: 130px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">件</span>
						</el-input>
					</div>
				</div>
				<!-- 自动获取 -->
				<div v-if="curItem.params.source === 'auto'" class="block-box">
					<!-- <div class="block-item block-item-class">
                <span class="label">商品分类</span>
                <SGoodsCate
                  @getValue="getValue"
                  style="width: 100%"
                ></SGoodsCate>
              </div> -->
					<div class="block-item block-item-class">
						<span class="label">商品排序</span>
						<el-radio-group v-model="curItem.params.auto.goodsSort" type="button">
							<el-radio label="all">默认</el-radio>
							<el-radio label="sales">销量</el-radio>
							<el-radio label="price">价格</el-radio>
						</el-radio-group>
					</div>
					<div class="block-item block-item-class">
						<span class="label">显示数量</span>
						<div class="item-slider ">
							<el-slider style="width: 100%" v-model="curItem.params.auto.showNum" :min="1" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeGoods(e,'showNum')"
							v-model="curItem.params.auto.showNum" size="mini" style="width: 130px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">件</span>
						</el-input>

					</div>
				</div>
				<!--  </el-tab-pane>
          <el-tab-pane key="2" label="样式设置"> -->
				<div v-if="curItem.style.column==2" class="block-box">
					<!-- <div class="block-title">广告位设置</div> -->
					<div class="block-item block-item-class">
						<span class="label">广告位</span>
						<div class="" style="display:flex">
							<div @click="radioFun('swipter',1)" class="s_r">
								<span v-if="curItem.style.swipter==1" class="s_radio_y">
									<span class="s_radio_active"></span>
								</span>
								<span v-else class="s_radio">
								</span>
								<span style="margin-left: 3px;font-size:14px">显示</span>
							</div>
							<div @click="radioFun('swipter',2)" class="s_r">
								<span v-if="curItem.style.swipter==2" class="s_radio_y">
									<span class="s_radio_active"></span>
								</span>
								<span v-else class="s_radio">
								</span>
								<span style="margin-left: 3px;font-size:14px">不显示</span>
							</div>
						</div>
					</div>
					<div v-if="curItem.style.swipter==1" class="sub-title">添加图片 (最多6张，可拖动排序）</div>
					<draggable v-if="curItem.style.swipter==1" :list="curItem.swipter" v-bind="{
				  animation: 120,
				  filter: 'input',
				  preventOnFilter: false,
				}">
						<div v-for="(item, index) in curItem.swipter" :key="index" class="block-box drag drage-banner">
							<div class="block-title">
								<a class="link" @click="handleDeleleSwipter(curItem, index)">
									<i class="el-icon-error"></i></a>
							</div>
							<div class="block-item">
								<img src="@/assets/icon/icon-move.png" alt="" style="width: 20px; height: 20px" />
								<div class="block-item-custom">
									<SImage width="70px" height="70px" v-model="item.imgUrl" tips="建议尺寸360*480"
										@update="item.imgName = $event.filename" />
								</div>
								<div class="block-item-common">
									<!-- <div class="block-item-common-row">
						<span class="label">图片</span>
						<span class="label value">{{ item.imgName }}</span>
					  </div> -->
									<div class="block-item-common-row">
										<!-- <span class="label">选择链接</span> -->
										<SLink v-model="item.link" />
									</div>
									<span>建议图片宽度360*480</span>
								</div>
							</div>
						</div>
					</draggable>
					<div v-if="curItem.swipter.length < 6 && curItem.style.swipter==1" class="data-add">
						<el-button icon="plus" @click="handleAddSwipter(6)">添加广告</el-button>
					</div>
				</div>
				
				<div class="block-box">
					<div class="block-item block-item-class">
						<span class="label">内容样式</span>
						<el-radio-group v-model="curItem.style.cardType" type="button">
							<el-radio label="flat">扁平</el-radio>
							<el-radio label="card">卡片</el-radio>
						</el-radio-group>
					</div>
					<!-- <div class="block-title">商品样式</div> -->
					<div class="block-item block-item-class">
						<span class="label">显示类型</span>
						<el-radio-group v-model="curItem.style.display" type="button">
							<el-radio label="list">两列平铺</el-radio>
							<el-radio :disabled="curItem.style.column === 1" label="slide">横向滑动</el-radio>
						</el-radio-group>
					</div>
					<div class="block-item block-item-class">
						<span class="label">分列数量</span>
						<el-radio-group v-model="curItem.style.column" type="button">
							<el-radio :disabled="curItem.style.display !== 'list'" :label="1">单列</el-radio>
							<el-radio :label="2">两列</el-radio>
							<el-radio :label="3">三列</el-radio>
						</el-radio-group>
					</div>
					<div class="block-item block-item-class">
						<span class="label">商品名称</span>
						<div class="" style="display:flex">
							<div @click="checkR(curItem.style.show,'goodsName',true)" class="s_r">
								<span v-if="radioF(curItem.style.show,'goodsName')" class="s_radio_y">
									<span class="s_radio_active"></span>
								</span>
								<span v-else class="s_radio">
								</span>
								<span style="margin-left: 3px;font-size:14px">显示</span>
							</div>
							<div @click="checkR(curItem.style.show,'goodsName',false)" class="s_r">
								<span v-if="!radioF(curItem.style.show,'goodsName')" class="s_radio_y">
									<span class="s_radio_active"></span>
								</span>
								<span v-else class="s_radio">
								</span>
								<span style="margin-left: 3px;font-size:14px">不显示</span>
							</div>
						</div>
					</div>
					<div v-if="radioF(curItem.style.show,'goodsName')" class="block-item block-item-class">
						<span class="label">商品加粗</span>
						<el-radio-group v-model="curItem.style.goodsWeight" type="button">
							<el-radio label="normal">不加粗</el-radio>
							<el-radio label="bold">加粗</el-radio>
						</el-radio-group>
					</div>
					<div v-if="radioF(curItem.style.show,'goodsName')" class="block-item block-item-class">
						<span class="label">商品字号</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.goodsSize" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'goodsSize')" v-model="curItem.style.goodsSize"
							size="mini" style="width: 130px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div v-if="radioF(curItem.style.show,'goodsName')" class="block-item block-item-class">
						<span class="label">商品行数</span>
						<el-radio-group v-model="curItem.style.goodsNameRows" type="button">
							<el-radio label="one">单行</el-radio>
							<el-radio label="two">双行</el-radio>
						</el-radio-group>
					</div>
					<div class="block-item block-item-class">
						<span class="label">商品价格</span>
						<div class="" style="display:flex">
							<div @click="checkR(curItem.style.show,'goodsPrice',true)" class="s_r">
								<span v-if="radioF(curItem.style.show,'goodsPrice')" class="s_radio_y">
									<span class="s_radio_active"></span>
								</span>
								<span v-else class="s_radio">
								</span>
								<span style="margin-left: 3px;font-size:14px">显示</span>
							</div>
							<div @click="checkR(curItem.style.show,'goodsPrice',false)" class="s_r">
								<span v-if="!radioF(curItem.style.show,'goodsPrice')" class="s_radio_y">
									<span class="s_radio_active"></span>
								</span>
								<span v-else class="s_radio">
								</span>
								<span style="margin-left: 3px;font-size:14px">不显示</span>
							</div>
						</div>
					</div>
					<div v-if="radioF(curItem.style.show,'goodsPrice')" class="block-item block-item-class">
						<span class="label">价格颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.priceColor" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.priceColor" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#FF0000"></SInput>
								</div>
								<div class="color-txt" @click="  onEditorResetColor( curItem.style, 'priceColor', '#FF0000' ) "> 重置 </div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">划线价格</span>
						<div class="" style="display:flex">
							<div @click="checkR(curItem.style.show,'linePrice',true)" class="s_r">
								<span v-if="radioF(curItem.style.show,'linePrice')" class="s_radio_y">
									<span class="s_radio_active"></span>
								</span>
								<span v-else class="s_radio">
								</span>
								<span style="margin-left: 3px;font-size:14px">显示</span>
							</div>
							<div @click="checkR(curItem.style.show,'linePrice',false)" class="s_r">
								<span v-if="!radioF(curItem.style.show,'linePrice')" class="s_radio_y">
									<span class="s_radio_active"></span>
								</span>
								<span v-else class="s_radio">
								</span>
								<span style="margin-left: 3px;font-size:14px">不显示</span>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">会员价格</span>
						<div class="" style="display:flex">
							<div @click="checkR(curItem.style.show,'goodsGrade',true)" class="s_r">
								<span v-if="radioF(curItem.style.show,'goodsGrade')" class="s_radio_y">
									<span class="s_radio_active"></span>
								</span>
								<span v-else class="s_radio">
								</span>
								<span style="margin-left: 3px;font-size:14px">显示</span>
							</div>
							<div @click="checkR(curItem.style.show,'goodsGrade',false)" class="s_r">
								<span v-if="!radioF(curItem.style.show,'goodsGrade')" class="s_radio_y">
									<span class="s_radio_active"></span>
								</span>
								<span v-else class="s_radio">
								</span>
								<span style="margin-left: 3px;font-size:14px">不显示</span>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">商品卖点</span>
						<div class="" style="display:flex">
							<div @click="checkR(curItem.style.show,'sellingPoint',true)" class="s_r">
								<span v-if="radioF(curItem.style.show,'sellingPoint')" class="s_radio_y">
									<span class="s_radio_active"></span>
								</span>
								<span v-else class="s_radio">
								</span>
								<span style="margin-left: 3px;font-size:14px">显示</span>
							</div>
							<div @click="checkR(curItem.style.show,'sellingPoint',false)" class="s_r">
								<span v-if="!radioF(curItem.style.show,'sellingPoint')" class="s_radio_y">
									<span class="s_radio_active"></span>
								</span>
								<span v-else class="s_radio">
								</span>
								<span style="margin-left: 3px;font-size:14px">不显示</span>
							</div>
						</div>
					</div>
					<div v-if="radioF(curItem.style.show,'sellingPoint')" class="block-item block-item-class">
						<span class="label">卖点颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.sellingColor"
									defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.sellingColor" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
					    onEditorResetColor(
					      curItem.style,
					      'sellingColor',
					      '#e3771f'
					    )
					  ">
									重置
								</div>
							</div>
						</div>
					</div>
					<div v-show="curItem.style.column < 3" class="block-item block-item-class">
						<span class="label">加购按钮</span>
						<div class="" style="display:flex">
							<div @click="checkR(curItem.style.show,'cartBtn',true)" class="s_r">
								<span v-if="radioF(curItem.style.show,'cartBtn')" class="s_radio_y">
									<span class="s_radio_active"></span>
								</span>
								<span v-else class="s_radio">
								</span>
								<span style="margin-left: 3px;font-size:14px">显示</span>
							</div>
							<div @click="checkR(curItem.style.show,'cartBtn',false)" class="s_r">
								<span v-if="!radioF(curItem.style.show,'cartBtn')" class="s_radio_y">
									<span class="s_radio_active"></span>
								</span>
								<span v-else class="s_radio">
								</span>
								<span style="margin-left: 3px;font-size:14px">不显示</span>
							</div>
						</div>
					</div>
					<div v-if="radioF(curItem.style.show,'cartBtn')" class="block-item block-item-class dancheck">
						<span class="label">购物车样式</span>
						<RadioGroup v-model="curItem.style.btnCartStyle" type="button">
							<Radio :label="1" style="padding:0 16px"><span class=" iconfont icon-jiagou1"></span></Radio>
							<Radio :label="2" style="padding:0 16px">
								<span class="card_style1"
									:style="{background:curItem.style.btnCartStyle==2?'#006aff':'#515a6e'}">
									<!-- <i class="iconfont icon-jiagou2" style="color:#fff;font-size:10px"></i> -->
									<i class="iconfont icon-jiagou3" style="color:#fff;font-size:10px"></i>
								</span>
							</Radio>
							<Radio :label="3" style="padding:0 16px"><span class=" iconfont icon-jiagou3"></span></Radio>
							<Radio :label="4" style="padding:0 16px"><span
									:style="{background:curItem.style.btnCartStyle==4?'#006aff':'#515a6e'}"
									class="card_style">购买</span></Radio>
						</RadioGroup>
					</div>
					<div v-if="radioF(curItem.style.show,'cartBtn')" class="block-item block-item-class">
						<span class="label">购物车颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.btnCartColor"
									defaultColor="#FF0000" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.btnCartColor" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
					  onEditorResetColor(
					    curItem.style,
					    'btnCartColor',
					    '#27c29a'
					  )
					">
									重置
								</div>
							</div>
						</div>
					</div>

					<div class="block-item block-item-class">
						<span class="label">商品销量</span>
						<div class="" style="display:flex">
							<div @click="checkR(curItem.style.show,'goodsSales',true)" class="s_r">
								<span v-if="radioF(curItem.style.show,'goodsSales')" class="s_radio_y">
									<span class="s_radio_active"></span>
								</span>
								<span v-else class="s_radio">
								</span>
								<span style="margin-left: 3px;font-size:14px">显示</span>
							</div>
							<div @click="checkR(curItem.style.show,'goodsSales',false)" class="s_r">
								<span v-if="!radioF(curItem.style.show,'goodsSales')" class="s_radio_y">
									<span class="s_radio_active"></span>
								</span>
								<span v-else class="s_radio">
								</span>
								<span style="margin-left: 3px;font-size:14px">不显示</span>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">商品标签</span>
						<div class="" style="display:flex">
							<div @click="checkR(curItem.style.show,'goodsTag',true)" class="s_r">
								<span v-if="radioF(curItem.style.show,'goodsTag')" class="s_radio_y">
									<span class="s_radio_active"></span>
								</span>
								<span v-else class="s_radio">
								</span>
								<span style="margin-left: 3px;font-size:14px">显示</span>
							</div>
							<div @click="checkR(curItem.style.show,'goodsTag',false)" class="s_r">
								<span v-if="!radioF(curItem.style.show,'goodsTag')" class="s_radio_y">
									<span class="s_radio_active"></span>
								</span>
								<span v-else class="s_radio">
								</span>
								<span style="margin-left: 3px;font-size:14px">不显示</span>
							</div>
						</div>
					</div>
					
					
					<div class="block-item block-item-class">
						<span class="label">热卖标签</span>
						<el-radio-group v-model="curItem.style.hotTag" type="button">
							<el-radio label="1">显示</el-radio>
							<el-radio label="2">不显示</el-radio>
						</el-radio-group>
					</div>
					<div v-if="curItem.style.hotTag==1" class="block-item has-tips block-item-class">
						<span class="label">热卖图片</span>
						<div class="flex-box">
							<SImage v-model="curItem.style.hotImg" width="70px" height="70px" />
							<div class="tips">
								建议图片大小为110*110尺寸的图片
							</div>
						</div>
					</div>
					
				</div>
				<div class="block-box">
					<!-- <div class="block-title">卡片样式</div> -->
					
					<div class="block-item block-item-class">
						<span class="label">圆角尺寸</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.borderRadius" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'borderRadius')"
							v-model="curItem.style.borderRadius" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">商品间距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.itemMargin" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'itemMargin')"
							v-model="curItem.style.itemMargin" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
				</div>
				<div class="block-box">
					<!-- <div class="block-title">组件样式</div> -->
					<div class="block-item block-item-class">
						<span class="label">上边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingY" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingY')" v-model="curItem.style.paddingY"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">下边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingY1" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingY1')" v-model="curItem.style.paddingY1"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">左边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingX" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingX')" v-model="curItem.style.paddingX"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">右边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingX1" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingX1')" v-model="curItem.style.paddingX1"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">组件背景</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.background" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.background" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
                        onEditorResetColor(
                          curItem.style,
                          'background',
                          '#ffffff'
                        )
                      ">
									重置
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- </el-tab-pane>
        </el-tabs> -->
			</div>

			<!-- 积分商品组 -->
			<div v-if="curItem.type == 'pointergoods'" class="editor-content editor-content-banner">
				<div class="block-box">
					<div class="block-item block-item-class">
						<span class="label">商品来源</span>
						<el-radio-group size="small" @change="goodChange" v-model="curItem.params.source" type="button">
							<el-radio label="auto">自动获取</el-radio>
							<el-radio label="choice">手动选择</el-radio>
							<el-radio label="category">选择分类</el-radio>
						</el-radio-group>
					</div>
				</div>
				<!-- 手动选择 -->
				<div v-if="curItem.params.source === 'choice'" class="block-box">
					<div class="block-title" style="margin-bottom:0">
						选择商品 ({{ curItem.data.length }}/50)
					</div>
					<small style="color:#888">最多可选择50个商品，超出将截取前50个商品</small>
					<SGoodsPointe :maxNum="50" v-model="curItem.data" />
				</div>
				<div v-if="curItem.params.source === 'category'" class="block-box">
					<div class="block-item block-item-class">
						<span class="label">商品分类</span>
						<SGoodsCatePointe :vals="curItem.params.auto.category" @getValue="getPointValue"
							style="width: 270px"></SGoodsCatePointe>
					</div>
					<div class="block-item block-item-class">
						<span class="label">显示数量</span>
						<div class="item-slider ">
							<el-slider style="width: 100%" v-model="curItem.params.auto.showNum" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeGoods(e,'showNum')"
							v-model="curItem.params.auto.showNum" size="mini" style="width: 130px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">件</span>
						</el-input>
					</div>
				</div>
				<!-- 自动获取 -->
				<div v-if="curItem.params.source === 'auto'" class="block-box">
					<div class="block-item block-item-class">
						<span class="label">商品排序</span>
						<el-radio-group v-model="curItem.params.auto.goodsSort" type="button">
							<el-radio label="all">默认</el-radio>
							<el-radio label="sales">销量</el-radio>
							<el-radio label="price">价格</el-radio>
						</el-radio-group>
					</div>
					<div class="block-item block-item-class">
						<span class="label">显示数量</span>
						<div class="item-slider ">
							<el-slider style="width: 100%" v-model="curItem.params.auto.showNum" :min="1" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeGoods(e,'showNum')"
							v-model="curItem.params.auto.showNum" size="mini" style="width: 130px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">件</span>
						</el-input>

					</div>
				</div>
				<!-- <div v-if="curItem.style.column==2" class="block-box">
	  			  <div class="block-title">广告位设置</div>
	  			  <div class="block-item block-item-class">
	  			    <span class="label">广告位</span>
	  					<div class="" style="display:flex">
	  						<div @click="radioFun('swipter',1)" class="s_r">
	  							<span v-if="curItem.style.swipter==1" class="s_radio_y">
	  								<span class="s_radio_active"></span>
	  							</span>
	  							<span v-else class="s_radio">
	  							</span>
	  							<span style="margin-left: 3px;">显示</span>
	  						</div>
	  						<div @click="radioFun('swipter',2)" class="s_r">
	  							<span v-if="curItem.style.swipter==2" class="s_radio_y">
	  								<span class="s_radio_active"></span>
	  							</span>
	  							<span v-else class="s_radio">
	  							</span>
	  							<span style="margin-left: 3px;">不显示</span>
	  						</div>
	  					</div>
	  			  </div>
	  			  <div v-if="curItem.style.swipter==1" class="sub-title">添加图片 (最多6张，可拖动排序）</div>
	  			  <draggable  v-if="curItem.style.swipter==1" :list="curItem.swipter" v-bind="{
	  				  animation: 120,
	  				  filter: 'input',
	  				  preventOnFilter: false,
	  				}"
	  			  >
	  				<div
	  				  v-for="(item, index) in curItem.swipter"
	  				  :key="index"
	  				  class="block-box drag drage-banner"
	  				>
	  				  <div class="block-title">
	  					<a class="link" @click="handleDeleleSwipter(curItem, index)">
	  					  <i class="el-icon-error"></i></a>
	  				  </div>
	  				  <div class="block-item">
	  					<img src="@/assets/icon/icon-move.png" alt="" style="width: 20px; height: 20px" />
	  					<div class="block-item-custom">
	  					  <SImage v-model="item.imgUrl" tips="建议尺寸360*480" @update="item.imgName = $event.filename" />
	  					</div>
	  					<div class="block-item-common">
	  					  <div class="block-item-common-row">
	  						<SLink v-model="item.link" />
	  					  </div>
	  					  <span>建议图片宽度360*480</span>
	  					</div>
	  				  </div>
	  				</div>
	  			  </draggable>
	  			  <div v-if="curItem.swipter.length < 6 && curItem.style.swipter==1" class="data-add">
	  				<el-button icon="plus" @click="handleAddSwipter(6)">添加广告</el-button>
	  			  </div>
	  			</div> -->
				<div class="block-box">
					<div class="block-item block-item-class">
						<span class="label">内容样式</span>
						<el-radio-group v-model="curItem.style.cardType" type="button">
							<el-radio label="flat">扁平</el-radio>
							<el-radio label="card">卡片</el-radio>
						</el-radio-group>
					</div>
					<!-- <div class="block-title">商品样式</div> -->
					<div class="block-item block-item-class">
						<span class="label">显示类型</span>
						<el-radio-group v-model="curItem.style.display" type="button">
							<el-radio label="list">两列平铺</el-radio>
							<el-radio :disabled="curItem.style.column === 1" label="slide">横向滑动</el-radio>
						</el-radio-group>
					</div>
					<div class="block-item block-item-class">
						<span class="label">分列数量</span>
						<el-radio-group v-model="curItem.style.column" type="button">
							<el-radio :disabled="curItem.style.display !== 'list'" :label="1">单列</el-radio>
							<el-radio :label="2">两列</el-radio>
							<el-radio :label="3">三列</el-radio>
						</el-radio-group>
					</div>
					<div class="block-item block-item-class">
						<span class="label">商品名称</span>
						<div class="" style="display:flex">
							<div @click="checkR(curItem.style.show,'goodsName',true)" class="s_r">
								<span v-if="radioF(curItem.style.show,'goodsName')" class="s_radio_y">
									<span class="s_radio_active"></span>
								</span>
								<span v-else class="s_radio">
								</span>
								<span style="margin-left: 3px;">显示</span>
							</div>
							<div @click="checkR(curItem.style.show,'goodsName',false)" class="s_r">
								<span v-if="!radioF(curItem.style.show,'goodsName')" class="s_radio_y">
									<span class="s_radio_active"></span>
								</span>
								<span v-else class="s_radio">
								</span>
								<span style="margin-left: 3px;">不显示</span>
							</div>
						</div>
					</div>
					<div v-if="radioF(curItem.style.show,'goodsName')" class="block-item block-item-class">
						<span class="label">名称加粗</span>
						<el-radio-group v-model="curItem.style.goodsWeight" type="button">
							<el-radio label="normal">不加粗</el-radio>
							<el-radio label="bold">加粗</el-radio>
						</el-radio-group>
					</div>
					<div v-if="radioF(curItem.style.show,'goodsName')" class="block-item block-item-class">
						<span class="label">名称字号</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.goodsSize" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'goodsSize')" v-model="curItem.style.goodsSize"
							size="mini" style="width: 130px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div v-if="radioF(curItem.style.show,'goodsName')" class="block-item block-item-class">
						<span class="label">商品行数</span>
						<el-radio-group v-model="curItem.style.goodsNameRows" type="button">
							<el-radio label="one">单行</el-radio>
							<el-radio label="two">双行</el-radio>
						</el-radio-group>
					</div>
					<div class="block-item block-item-class">
						<span class="label">商品积分</span>
						<div class="" style="display:flex">
							<div @click="checkR(curItem.style.show,'goodsPrice',true)" class="s_r">
								<span v-if="radioF(curItem.style.show,'goodsPrice')" class="s_radio_y">
									<span class="s_radio_active"></span>
								</span>
								<span v-else class="s_radio">
								</span>
								<span style="margin-left: 3px;">显示</span>
							</div>
							<div @click="checkR(curItem.style.show,'goodsPrice',false)" class="s_r">
								<span v-if="!radioF(curItem.style.show,'goodsPrice')" class="s_radio_y">
									<span class="s_radio_active"></span>
								</span>
								<span v-else class="s_radio">
								</span>
								<span style="margin-left: 3px;">不显示</span>
							</div>
						</div>
					</div>
					<div v-if="radioF(curItem.style.show,'goodsPrice')" class="block-item block-item-class">
						<span class="label">积分颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.priceColor" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.priceColor" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#FF0000"></SInput>
								</div>
								<div class="color-txt" @click="
					    onEditorResetColor(
					      curItem.style,
					      'priceColor',
					      '#FF0000'
					    )
					  ">
									重置
								</div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">商品现金</span>
						<div class="" style="display:flex">
							<div @click="checkR(curItem.style.show,'goodsGrade',true)" class="s_r">
								<span v-if="radioF(curItem.style.show,'goodsGrade')" class="s_radio_y">
									<span class="s_radio_active"></span>
								</span>
								<span v-else class="s_radio">
								</span>
								<span style="margin-left: 3px;">显示</span>
							</div>
							<div @click="checkR(curItem.style.show,'goodsGrade',false)" class="s_r">
								<span v-if="!radioF(curItem.style.show,'goodsGrade')" class="s_radio_y">
									<span class="s_radio_active"></span>
								</span>
								<span v-else class="s_radio">
								</span>
								<span style="margin-left: 3px;">不显示</span>
							</div>
						</div>
					</div>
					<div v-if="radioF(curItem.style.show,'goodsGrade')" class="block-item block-item-class">
						<span class="label">现金颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.sellingColor"
									defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.sellingColor" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
					    onEditorResetColor(
					      curItem.style,
					      'sellingColor',
					      '#e3771f'
					    )
					  ">
									重置
								</div>
							</div>
						</div>
					</div>
					<div v-show="curItem.style.column < 3" class="block-item block-item-class">
						<span class="label">兑换按钮</span>
						<div class="" style="display:flex">
							<div @click="checkR(curItem.style.show,'cartBtn',true)" class="s_r">
								<span v-if="radioF(curItem.style.show,'cartBtn')" class="s_radio_y">
									<span class="s_radio_active"></span>
								</span>
								<span v-else class="s_radio">
								</span>
								<span style="margin-left: 3px;">显示</span>
							</div>
							<div @click="checkR(curItem.style.show,'cartBtn',false)" class="s_r">
								<span v-if="!radioF(curItem.style.show,'cartBtn')" class="s_radio_y">
									<span class="s_radio_active"></span>
								</span>
								<span v-else class="s_radio">
								</span>
								<span style="margin-left: 3px;">不显示</span>
							</div>
						</div>
					</div>
					<div v-if="radioF(curItem.style.show,'cartBtn')" class="block-item block-item-class dancheck">
						<span class="label">兑换样式</span>
						<RadioGroup v-model="curItem.style.btnCartStyle" type="button">
							<Radio :label="1" style="padding:0 16px"><span class=" iconfont icon-jiagou1"></span></Radio>
							<Radio :label="2" style="padding:0 16px">
								<span class="card_style1"
									:style="{background:curItem.style.btnCartStyle==2?'#006aff':'#515a6e'}">
									<!-- <i class="iconfont icon-jiagou2" style="color:#fff;font-size:10px"></i> -->
									<i class="iconfont icon-jiagou3" style="color:#fff;font-size:10px"></i>
								</span>
							</Radio>
							<Radio :label="3" style="padding:0 16px"><span class=" iconfont icon-jiagou3"></span></Radio>
							<Radio :label="4" style="padding:0 16px"><span
									:style="{background:curItem.style.btnCartStyle==4?'#006aff':'#515a6e'}"
									class="card_style">兑换</span></Radio>
						</RadioGroup>
					</div>
					<div v-if="radioF(curItem.style.show,'cartBtn')" class="block-item block-item-class">
						<span class="label">兑换颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.btnCartColor"
									defaultColor="#FF0000" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.btnCartColor" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
					  onEditorResetColor(
					    curItem.style,
					    'btnCartColor',
					    '#27c29a'
					  )
					">
									重置
								</div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">兑换数量</span>
						<div class="" style="display:flex">
							<div @click="checkR(curItem.style.show,'goodsSales',true)" class="s_r">
								<span v-if="radioF(curItem.style.show,'goodsSales')" class="s_radio_y">
									<span class="s_radio_active"></span>
								</span>
								<span v-else class="s_radio">
								</span>
								<span style="margin-left: 3px;">显示</span>
							</div>
							<div @click="checkR(curItem.style.show,'goodsSales',false)" class="s_r">
								<span v-if="!radioF(curItem.style.show,'goodsSales')" class="s_radio_y">
									<span class="s_radio_active"></span>
								</span>
								<span v-else class="s_radio">
								</span>
								<span style="margin-left: 3px;">不显示</span>
							</div>
						</div>
					</div>
					
					<div class="block-item block-item-class">
						<span class="label">热卖标签</span>
						<el-radio-group v-model="curItem.style.hotTag" type="button">
							<el-radio label="1">显示</el-radio>
							<el-radio label="2">不显示</el-radio>
						</el-radio-group>
					</div>
					<div v-if="curItem.style.hotTag==1" class="block-item has-tips block-item-class">
						<span class="label">热卖图片</span>
						<div class="flex-box">
							<SImage v-model="curItem.style.hotImg" width="70px" height="70px" />
							<div class="tips">
								建议图片大小为110*110尺寸的图片
							</div>
						</div>
					</div>
					
				</div>
				<div class="block-box">
					<!-- <div class="block-title">卡片样式</div> -->
					
					<div class="block-item block-item-class">
						<span class="label">圆角尺寸</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.borderRadius" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'borderRadius')"
							v-model="curItem.style.borderRadius" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">商品间距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.itemMargin" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'itemMargin')"
							v-model="curItem.style.itemMargin" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
				</div>
				<div class="block-box">
					<!-- <div class="block-title">组件样式</div> -->
					<div class="block-item block-item-class">
						<span class="label">上边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingY" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingY')" v-model="curItem.style.paddingY"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">下边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingY1" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingY1')" v-model="curItem.style.paddingY1"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">左边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingX" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingX')" v-model="curItem.style.paddingX"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">右边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingX1" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingX1')" v-model="curItem.style.paddingX1"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">组件背景</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.background" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.background" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
	                    onEditorResetColor(
	                      curItem.style,
	                      'background',
	                      '#ffffff'
	                    )
	                  ">
									重置
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- 导航组 -->
			<div v-if="curItem.type == 'navBar'" class="editor-content editor-content-banner">
				<!-- <el-tabs>
          <el-tab-pane key="1" label="内容设置"> -->
				<div class="sub-title">
					（最少3个，最多20个，可拖动排序)，建议图片尺寸200x200，比例1:1
				</div>
				<draggable :list="curItem.data" v-bind="{
                animation: 120,
                filter: 'input',
                preventOnFilter: false,
              }">
					<div v-for="(item, index) in curItem.data" :key="index" class="block-box drag drage-banner">
						<div class="block-title">
							<!-- <span class="left">导航 {{ index + 1 }}</span> -->
							<a class="link" @click="handleDeleleData(curItem, index)"><i class="el-icon-error"></i></a>
						</div>
						<div class="block-item">
							<img src="@/assets/icon/icon-move.png" alt="" style="width: 20px; height: 20px" />
							<div class="block-item-custom">
								<SImage width="70px" height="70px" v-model="item.imgUrl" tips="建议尺寸100×100" />
							</div>
							<div class="block-item-common">
								<div class="block-item-common-row">
									<!-- <span class="label">名称</span> -->
									<el-input size="small"  v-model="item.text" />
								</div>
								<div class="block-item-common-row">
									<!-- <span class="label">链接</span> -->
									<SLink v-model="item.link" />
								</div>
							</div>
						</div>
					</div>
				</draggable>
				<div v-if="curItem.data.length < 20" class="data-add">
					<el-button icon="plus" @click="handleAddData(20)">添加导航</el-button>
				</div>
				<!-- </el-tab-pane>
          <el-tab-pane key="2" label="样式设置"> -->
				<div class="block-box">
					<!-- <div class="block-title">内容样式</div> -->
					<div class="block-item block-item-class">
						<span class="label">交互样式</span>
						<el-radio-group v-model="curItem.params.interactive" type="button">
							<el-radio :label="1">平滑</el-radio>
							<el-radio :label="2">分页</el-radio>
						</el-radio-group>
					</div>
					<div v-if="curItem.params.interactive==1" class="block-item block-item-class">
						<span class="label">每页行数</span>
						<el-radio-group v-model="curItem.params.rowNum" type="button">
							<el-radio :label="1">1行</el-radio>
							<el-radio :label="2">2行</el-radio>
						</el-radio-group>
					</div>
					<div class="block-item block-item-class">
						<span class="label">每行数量</span>
						<el-radio-group v-model="curItem.style.rowsNum" type="button">
							<el-radio :label="3">3个</el-radio>
							<el-radio :label="4">4个</el-radio>
							<el-radio :label="5">5个</el-radio>
						</el-radio-group>
					</div>
					<div class="block-item block-item-class">
						<span class="label">按钮形状</span>
						<el-radio-group v-model="curItem.style.navRadius" type="button">
							<el-radio :label="1">方形</el-radio>
							<el-radio :label="2">圆角</el-radio>
							<el-radio :label="3">圆形</el-radio>
						</el-radio-group>
					</div>
					<!-- <div class="block-item block-item-class">
						<span class="label">按钮形状</span>
						<div class="navstyle" style="display: flex;">
							<div @click="setFun(1)" :class="[curItem.style.navRadius==1?'navactive1':'navb']"
								style="margin-right:10px;cursor: pointer; height: 30px;width: 30px;background-color: #ededed;">
							</div>
							<div @click="setFun(2)" :class="[curItem.style.navRadius==2?'navactive1':'navb']"
								style="margin-right:10px;cursor: pointer; height: 30px;width: 30px;background-color: #ededed;border-radius:3px">
							</div>
							<div @click="setFun(3)" :class="[curItem.style.navRadius==3?'navactive1':'navb']"
								style="margin-right:10px;cursor: pointer; height: 30px;width: 30px;background-color: #ededed;border-radius:50%">
							</div>
						</div>
					</div> -->

					<div class="block-item block-item-class">
						<span class="label">文字颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.textColor" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.textColor" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
                        onEditorResetColor(curItem.style, 'textColor', '#000')
                      ">
									重置
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="block-box">
					<!-- <div class="block-title">组件样式</div> -->
					<div class="block-item block-item-class">
						<span class="label">组件背景</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.zubackground"
									defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.zubackground" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#fff"></SInput>
								</div>
								<div class="color-txt" @click="
			            onEditorResetColor(curItem.style, 'zubackground', '#fff')
			          ">
									重置
								</div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">背景颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.background" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.background" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
                        onEditorResetColor(curItem.style, 'background', '#fff')
                      ">
									重置
								</div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">上边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingY" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingY')" v-model="curItem.style.paddingY"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">下边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingY1" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingY1')" v-model="curItem.style.paddingY1"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">左边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingX" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingX')" v-model="curItem.style.paddingX"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">右边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingX1" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingX1')" v-model="curItem.style.paddingX1"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">上圆角</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.borderRadius" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'borderRadius')"
							v-model="curItem.style.borderRadius" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">下圆角</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.borderRadius1" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'borderRadius1')"
							v-model="curItem.style.borderRadius1" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
				</div>
				<!-- </el-tab-pane>
        </el-tabs> -->
			</div>

			<!-- 门店分类 -->
			<div v-if="curItem.type == 'life'" class="editor-content editor-content-banner">
				<!-- <el-tabs>
	      <el-tab-pane key="1" label="内容设置"> -->
				<div class="sub-title">
					(最少3个，最多10个，可拖动排序)，建议图片尺寸200x200，比例1:1
				</div>
				<draggable :list="curItem.data" v-bind="{
	            animation: 120,
	            filter: 'input',
	            preventOnFilter: false,
	          }">
					<div v-for="(item, index) in curItem.data" :key="index" class="block-box drag drage-banner">
						<div class="block-title">
							<!-- <span class="left">导航 {{ index + 1 }}</span> -->
							<a class="link" @click="handleDeleleData(curItem, index)"><i class="el-icon-error"></i></a>
						</div>
						<div class="block-item">
							<img src="@/assets/icon/icon-move.png" alt="" style="width: 20px; height: 20px" />
							<div class="block-item-custom">
								<SImage width="70px" height="70px" v-model="item.imgUrl" tips="建议尺寸100×100" />
							</div>
							<div class="block-item-common">
								<div class="block-item-common-row">
									<!-- <span class="label">名称</span> -->
									<el-input size="small" v-model="item.text" />
								</div>
								<div class="block-item-common-row">
									<!-- <span class="label">链接</span> -->
									<SLink v-model="item.link" />
								</div>
							</div>
						</div>
					</div>
				</draggable>
				<div v-if="curItem.data.length < 10" class="data-add">
					<el-button icon="plus" @click="handleAddData(10)">添加导航</el-button>
				</div>
				<!-- </el-tab-pane>
	      <el-tab-pane key="2" label="样式设置"> -->
				<div class="block-box">
					<!-- <div class="block-title">内容样式</div> -->
					<div class="block-item block-item-class">
						<span class="label">商家排版</span>
						<el-radio-group v-model="curItem.style.layout" type="button">
							<el-radio :label="1">含商品组</el-radio>
							<el-radio :label="2">不含商品组</el-radio>
						</el-radio-group>
					</div>
					<div class="block-item block-item-class">
						<span class="label">每行数量</span>
						<el-radio-group v-model="curItem.style.rowsNum" type="button">
							<el-radio :label="3">3个</el-radio>
							<el-radio :label="4">4个</el-radio>
							<el-radio :label="5">5个</el-radio>
						</el-radio-group>
					</div>
					<div class="block-item block-item-class">
						<span class="label">按钮形状</span>
						<el-radio-group v-model="curItem.style.navRadius" type="button">
							<el-radio :label="1">方形</el-radio>
							<el-radio :label="2">圆角</el-radio>
							<el-radio :label="3">圆形</el-radio>
						</el-radio-group>
						<!-- <div class="navstyle" style="display: flex;">
							<div @click="setFun(1)" :class="[curItem.style.navRadius==1?'navactive1':'navb']"
								style="margin-right:10px;cursor: pointer; height: 30px;width: 30px;background-color: #ededed;">
							</div>
							<div @click="setFun(2)" :class="[curItem.style.navRadius==2?'navactive1':'navb']"
								style="margin-right:10px;cursor: pointer; height: 30px;width: 30px;background-color: #ededed;border-radius:3px">
							</div>
							<div @click="setFun(3)" :class="[curItem.style.navRadius==3?'navactive1':'navb']"
								style="margin-right:10px;cursor: pointer; height: 30px;width: 30px;background-color: #ededed;border-radius:50%">
							</div>
						</div> -->
					</div>
					<div class="block-item block-item-class">
						<span class="label">文字颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.textColor" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.textColor" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
	                    onEditorResetColor(curItem.style, 'textColor', '#000')
	                  ">
									重置
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="block-box">
					<!-- <div class="block-title">组件样式</div> -->
					<div class="block-item block-item-class">
						<span class="label">组件背景</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.zubackground"
									defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.zubackground" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#fff"></SInput>
								</div>
								<div class="color-txt" @click="
	  			            onEditorResetColor(curItem.style, 'zubackground', '#fff')
	  			          ">
									重置
								</div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">背景颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.background" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.background" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
	                    onEditorResetColor(curItem.style, 'background', '#fff')
	                  ">
									重置
								</div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">上边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingY" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingY')" v-model="curItem.style.paddingY"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">下边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingY1" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingY1')" v-model="curItem.style.paddingY1"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">左边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingX" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingX')" v-model="curItem.style.paddingX"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">右边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingX1" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingX1')" v-model="curItem.style.paddingX1"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">上圆角</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.borderRadius" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'borderRadius')"
							v-model="curItem.style.borderRadius" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">下圆角</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.borderRadius1" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'borderRadius1')"
							v-model="curItem.style.borderRadius1" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
				</div>
				<!-- </el-tab-pane>
	    </el-tabs> -->
			</div>
			<!-- 门店列表 -->
			<div v-if="curItem.type == 'lifelist'" class="editor-content editor-content-banner">
				<div class="block-box">
					<div class="block-item block-item-class">
						<span class="label">门店来源</span>
						<el-radio-group v-model="curItem.params.source" type="button">
							<el-radio label="auto">自动获取</el-radio>
							<!-- <el-radio label="choice">手动选择</el-radio> -->
							<el-radio label="category">选择分类</el-radio>
						</el-radio-group>
					</div>
				</div>
				<!-- 手动选择 -->
				<div v-if="curItem.params.source === 'choice'" class="block-box">
					<div class="block-title" style="margin-bottom:0">
						选择门店 ({{ curItem.data.length }}/50)
					</div>
					<small style="color:#888">最多可选择50个门店，超出将截取前50个门店</small>
					<SGoods :maxNum="50" v-model="curItem.data" />
				</div>
				<div v-if="curItem.params.source === 'category'" class="block-box">
					<div class="block-item block-item-class">
						<span class="label">门店分类</span>
						<SstoreCate :vals="curItem.params.auto.category" @getValue="getValue" style="width: 270px">
						</SstoreCate>
					</div>

				</div>
				<div class="block-box">
					<div v-if="curItem.params.source === 'category' || curItem.params.source === 'auto'"
						class="block-item block-item-class">
						<span class="label">显示数量</span>
						<div class="item-slider ">
							<el-slider style="width: 100%" v-model="curItem.params.auto.showNum" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeGoods(e,'showNum')"
							v-model="curItem.params.auto.showNum" size="mini" style="width: 130px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">家</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">商品展示</span>
						<el-radio-group v-model="curItem.params.auto.show_goods" type="button">
							<el-radio :label="1">显示商品</el-radio>
							<el-radio :label="0">不显示商品</el-radio>
						</el-radio-group>
					</div>
				</div>
				<div class="block-box">
					<!-- <div class="block-title">组件样式</div> -->
					<div class="block-item block-item-class">
						<span class="label">组件背景</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.zubackground"
									defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.zubackground" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#fff"></SInput>
								</div>
								<div class="color-txt" @click="
				            onEditorResetColor(curItem.style, 'zubackground', '#fff')
				          ">
									重置
								</div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">上边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingY" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingY')" v-model="curItem.style.paddingY"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">下边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingY1" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingY1')" v-model="curItem.style.paddingY1"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">左边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingX" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingX')" v-model="curItem.style.paddingX"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">右边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingX1" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingX1')" v-model="curItem.style.paddingX1"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
				</div>

			</div>
			<!-- 图片橱窗 -->
			<div v-if="curItem.type == 'window'" class="editor-content editor-content-banner">
				<!-- <el-tabs>
          <el-tab-pane key="1" label="内容设置"> -->
				<div class="sub-title">添加图片 (最多10个，可拖动排序)</div>
				<draggable :list="curItem.data" v-bind="{
                animation: 120,
                filter: 'input',
                preventOnFilter: false,
              }">
					<div v-for="(item, index) in curItem.data" :key="index" class="block-box drag drage-banner">
						<div class="block-title">
							<!-- <span class="left">图片 {{ index + 1 }}</span> -->
							<a class="link" @click="handleDeleleData(curItem, index)"><i class="el-icon-error"></i></a>
						</div>
						<div class="block-item">
							<div class="block-item-custom">
								<SImage width="70px" height="70px" v-model="item.imgUrl" @update="item.imgName = $event.file_name" />
							</div>
							<div class="block-item-common">
								<!-- <div class="block-item-common-row">
									<span class="label">名称</span>
									<span class="label value">{{ item.imgName }}</span>
								</div> -->
								<div class="block-item-common-row">
									<!-- <span class="label">链接</span> -->
									<SLink v-model="item.link" />
								</div>
							</div>
						</div>
					</div>
				</draggable>
				<div v-if="curItem.data.length < 10" class="data-add">
					<el-button icon="plus" @click="handleAddData(10)">添加图片</el-button>
				</div>
				<!-- </el-tab-pane>
          <el-tab-pane key="2" label="样式设置"> -->
				<div class="block-box">
					<!-- <div class="block-title">内容样式</div> -->
					<div class="block-item block-item-class">
						<span class="label">每行数量</span>
						<el-radio-group v-model="curItem.style.layout" type="button">
							<el-radio :label="2">2列</el-radio>
							<el-radio :label="3">3列</el-radio>
							<el-radio :label="4">4列</el-radio>
							<el-radio :label="-1">橱窗</el-radio>
						</el-radio-group>
					</div>
					<div class="block-item block-item-class">
						<span class="label">上下边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingTop" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingTop')"
							v-model="curItem.style.paddingTop" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">左右边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingLeft" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingLeft')"
							v-model="curItem.style.paddingLeft" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
				</div>
				<div class="block-box">
					<!-- <div class="block-title">组件样式</div> -->
					<div class="block-item block-item-class">
						<span class="label">背景颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.background" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.background" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
                        onEditorResetColor(curItem.style, 'background', '#fff')
                      ">
									重置
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- </el-tab-pane>
        </el-tabs> -->
			</div>

			<!-- 热区组 -->
			<div v-if="curItem.type == 'hotZone'" class="editor-content editor-content-banner">
				<!-- <el-tabs>
          <el-tab-pane key="1" label="内容设置"> -->

				<div class="block-box" style="margin-bottom: 35px;">
					<!-- <div class="block-title">
						<span class="left">背景图片</span>
					</div> -->
					<div class="block-item block-item-custom-l20">
						<div class="block-item-custom">
							<SImage width="70px" height="70px" v-model="curItem.data.imgUrl" tips="建议尺寸宽750"
								@update="curItem.data.imgName = $event.filename" />
						</div>
						<div class="block-item-common">
							<div class="block-item-common-row">
								<span class="label">实现点击图片不同位置，跳转不同的链接</span>
								<!-- <span class="label value">{{ curItem.data.imgName }}</span> -->
							</div>
							<div class="block-item-common-row">
								<!-- <span class="label">链接</span> -->
								<SHotZone v-model="curItem.data.maps" :image="curItem.data.imgUrl" />
							</div>
						</div>
					</div>
					<!-- <div class="sub-title">实现点击图片不同位置，跳转不同的链接</div> -->
				</div>
				
				<!-- </el-tab-pane>
          <el-tab-pane key="2" label="样式设置"> -->
				<div class="block-box" >
					<!-- <div class="block-title">组件样式</div> -->
					<div class="block-item block-item-class">
						<span class="label">组件背景</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.background" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.background" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
			            onEditorResetColor(curItem.style, 'background', '#fff')
			          ">
									重置
								</div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">上边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingTop" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingTop')"
							v-model="curItem.style.paddingTop" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">下边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingBottom" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingBottom')"
							v-model="curItem.style.paddingBottom" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">左边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingLeft" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingLeft')"
							v-model="curItem.style.paddingLeft" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">右边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingRight" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingRight')"
							v-model="curItem.style.paddingRight" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">上圆角</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.radiusTop" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'radiusTop')" v-model="curItem.style.radiusTop"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">下圆角</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.radiusBottom" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'radiusBottom')"
							v-model="curItem.style.radiusBottom" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
				</div>
				<!-- </el-tab-pane>
        </el-tabs> -->
			</div>

			<!-- 关注公众号 -->
			<div v-if="curItem.type == 'officialAccount'" class="editor-content">
				<div class="block-box">
					<div class="text-describe">
						<p>1、该组件仅支持微信小程序端，其他应用端不显示。</p>
						<p class="empty"></p>
						<p>
							2、使用组件前需前往<a href="https://mp.weixin.qq.com" target="_blank">微信小程序管理后台</a>“设置” > “接口设置” >
							“公众号关注组件”中设置要展示的公众号，设置的公众号需与微信小程序主体一致。
						</p>
						<p class="empty"></p>
						<p>
							3、当微信小程序从扫二维码场景（场景值为1011）打开时，才具有展示引导关注公众号组件的能力。
						</p>
					</div>
				</div>
			</div>

			<!-- 礼券 -->
			<!-- 礼券 -->
				<div v-if="curItem.type == 'coupon'" class="editor-content editor-content-banner">
					<!-- <el-tabs>
			  <el-tab-pane key="1" label="内容设置"> -->
					<div class="block-box">
						<div class="block-item block-item-class">
							<span class="label">数据来源</span>
							<el-radio-group v-model="curItem.params.source" type="button">
								<el-radio label="auto">自动获取</el-radio>
								<el-radio label="choice">手动选择</el-radio>
							</el-radio-group>
						</div>
					</div>
					
					<!-- 手动选择 -->
					<div v-if="curItem.params.source === 'choice'" class="block-box">
						<div class="block-title">
							选择礼券 ({{ curItem.data.length }})
						</div>
						<SCoupon v-model="curItem.data" :maxNum="15" />
					</div>
					<!-- 自动获取 -->
					<div v-if="curItem.params.source === 'auto'" class="block-box">
						<!-- <div class="block-title">礼券内容</div> -->
						<div class="block-item block-item-class">
							<span class="label">显示数量</span>
							<div class="block-item-right flex_c_s">
								<el-input size="small" class="flex1" v-model="curItem.params.showNum" :min="1" :max="15" />
								<span class="unit-text">
									<span>个</span>
								</span>
							</div>
						</div>
					</div>
					<!-- </el-tab-pane>
			  <el-tab-pane key="2" label="样式设置"> -->
					<div class="block-box">
						<!-- <div class="block-title">组件样式</div> -->
						<div class="block-item block-item-class">
							<span class="label">礼券名称</span>
							<div class="block-item-right flex_c_s">
								<el-input size="small" class="flex1" v-model="curItem.params.title" />
							</div>
						</div>
						<div class="block-item block-item-class">
							<span class="label">名称颜色</span>
							<div class="item-colorPicker">
								<div class="color-picker-box">
									<el-color-picker size="small" v-model="curItem.style.titleColor" defaultColor="#fff" />
								</div>
								<div class="reset-color">
									<div class="ipt">
										<SInput v-model="curItem.style.titleColor" width="100px" height="32px"
											border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
									</div>
									<div class="color-txt" @click="
				            onEditorResetColor(curItem.style, 'titleColor', '#fff')
				          ">
										重置
									</div>
								</div>
							</div>
						</div>
						<div class="block-item block-item-class">
							<span class="label">组件背景</span>
							<div class="item-colorPicker">
								<div class="color-picker-box">
									<el-color-picker size="small" v-model="curItem.style.zubackground"
										defaultColor="#fff" />
								</div>
								<div class="reset-color">
									<div class="ipt">
										<SInput v-model="curItem.style.zubackground" width="100px" height="32px"
											border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
									</div>
									<div class="color-txt" @click="
				            onEditorResetColor(curItem.style, 'zubackground', '#fff')
				          ">
										重置
									</div>
								</div>
							</div>
						</div>
						<div class="block-item block-item-class">
							<span class="label">上边距</span>
							<div class="item-slider">
								<el-slider style="width: 100%" v-model="curItem.style.paddingTop" :min="0" :max="50" />
							</div>
							<el-input type="number" @input="e=>changeInput(e,'paddingTop')"
								v-model="curItem.style.paddingTop" size="mini" style="width: 150px;margin-left: 10px;"
								placeholder="请输入">
								<span slot="suffix" class="input_text" style="">PX</span>
							</el-input>
						</div>
						<div class="block-item block-item-class">
							<span class="label">下边距</span>
							<div class="item-slider">
								<el-slider style="width: 100%" v-model="curItem.style.paddingBottom" :min="0" :max="50" />
							</div>
							<el-input type="number" @input="e=>changeInput(e,'paddingBottom')"
								v-model="curItem.style.paddingBottom" size="mini" style="width: 150px;margin-left: 10px;"
								placeholder="请输入">
								<span slot="suffix" class="input_text" style="">PX</span>
							</el-input>
						</div>
						<div class="block-item block-item-class">
							<span class="label">左边距</span>
							<div class="item-slider">
								<el-slider style="width: 100%" v-model="curItem.style.paddingLeft" :min="0" :max="50" />
							</div>
							<el-input type="number" @input="e=>changeInput(e,'paddingLeft')"
								v-model="curItem.style.paddingLeft" size="mini" style="width: 150px;margin-left: 10px;"
								placeholder="请输入">
								<span slot="suffix" class="input_text" style="">PX</span>
							</el-input>
						</div>
						<div class="block-item block-item-class">
							<span class="label">右边距</span>
							<div class="item-slider">
								<el-slider style="width: 100%" v-model="curItem.style.paddingRight" :min="0" :max="50" />
							</div>
							<el-input type="number" @input="e=>changeInput(e,'paddingRight')"
								v-model="curItem.style.paddingRight" size="mini" style="width: 150px;margin-left: 10px;"
								placeholder="请输入">
								<span slot="suffix" class="input_text" style="">PX</span>
							</el-input>
						</div>
						<div class="block-item block-item-class">
							<span class="label">上圆角</span>
							<div class="item-slider">
								<el-slider style="width: 100%" v-model="curItem.style.borderRadius" :min="0" :max="50" />
							</div>
							<el-input type="number" @input="e=>changeInput(e,'borderRadius')"
								v-model="curItem.style.borderRadius" size="mini" style="width: 150px;margin-left: 10px;"
								placeholder="请输入">
								<span slot="suffix" class="input_text" style="">PX</span>
							</el-input>
						</div>
						<div class="block-item block-item-class">
							<span class="label">下圆角</span>
							<div class="item-slider">
								<el-slider style="width: 100%" v-model="curItem.style.borderRadius1" :min="0" :max="50" />
							</div>
							<el-input type="number" @input="e=>changeInput(e,'borderRadius1')"
								v-model="curItem.style.borderRadius1" size="mini" style="width: 150px;margin-left: 10px;"
								placeholder="请输入">
								<span slot="suffix" class="input_text" style="">PX</span>
							</el-input>
						</div>
						<div class="block-item block-item-class">
							<span class="label">背景颜色</span>
							<div class="item-colorPicker">
								<div class="color-picker-box">
									<el-color-picker size="small" v-model="curItem.style.background" defaultColor="#fff" />
								</div>
								<div class="reset-color">
									<div class="ipt">
										<SInput v-model="curItem.style.background" width="100px" height="32px"
											border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
									</div>
									<div class="color-txt" @click="
			                onEditorResetColor(curItem.style, 'background', '#fff')
			              ">
										重置
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="block-box">
						<!-- <div class="block-title">礼券样式</div> -->
						<div class="block-item block-item-class">
							<span class="label">左右间距</span>
							<div class="item-slider">
								<el-slider style="width: 100%" v-model="curItem.style.marginRight" :min="0" :max="40" />
							</div>
							<el-input type="number" @input="e=>changeInput(e,'marginRight')"
								v-model="curItem.style.marginRight" size="mini" style="width: 150px;margin-left: 10px;"
								placeholder="请输入">
								<span slot="suffix" class="input_text" style="">PX</span>
							</el-input>
						</div>
						<div class="block-item block-item-class">
							<span class="label">中间线条颜色</span>
							<div class="item-colorPicker">
								<div class="color-picker-box">
									<el-color-picker size="small" v-model="curItem.style.receiveBgColor"
										defaultColor="#ffa708" />
								</div>
								<div class="reset-color">
									<div class="ipt">
										<SInput v-model="curItem.style.receiveBgColor" width="100px" height="32px"
											border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
									</div>
									<div class="color-txt" @click="
						    onEditorResetColor(
						      curItem.style,
						      'receiveBgColor',
						      '#ffa708'
						    )
						  ">
										重置
									</div>
								</div>
							</div>
						</div>
						<div class="block-item block-item-class">
							<span class="label">礼券背景颜色</span>
							<div class="item-colorPicker">
								<div class="color-picker-box">
									<el-color-picker size="small" v-model="curItem.style.couponBgColor"
										defaultColor="#ffa708" />
								</div>
								<div class="reset-color">
									<div class="ipt">
										<SInput v-model="curItem.style.couponBgColor" width="100px" height="32px"
											border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
									</div>
									<div class="color-txt" @click="
			                onEditorResetColor(
			                  curItem.style,
			                  'couponBgColor',
			                  '#ffa708'
			                )
			              ">
										重置
									</div>
								</div>
							</div>
						</div>
						<div class="block-item block-item-class">
							<span class="label">满减文字颜色</span>
							<div class="item-colorPicker">
								<div class="color-picker-box">
									<el-color-picker size="small" v-model="curItem.style.couponTextColor"
										defaultColor="#fff" />
								</div>
								<div class="reset-color">
									<div class="ipt">
										<SInput v-model="curItem.style.couponTextColor" width="100px" height="32px"
											border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
									</div>
									<div class="color-txt" @click="
			                onEditorResetColor(
			                  curItem.style,
			                  'couponTextColor',
			                  '#ffffff'
			                )
			              ">
										重置
									</div>
								</div>
							</div>
						</div>
						<!-- <div class="block-item block-item-class">
							<span class="label">领取按钮颜色</span>
							<div class="item-colorPicker">
								<div class="color-picker-box">
									<el-color-picker size="small" v-model="curItem.style.receiveBgColor"
										defaultColor="#717070" />
								</div>
								<div class="reset-color">
									<div class="ipt">
										<SInput v-model="curItem.style.receiveBgColor" width="100px" height="32px"
											border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
									</div>
									<div class="color-txt" @click="
			                onEditorResetColor(
			                  curItem.style,
			                  'receiveBgColor',
			                  '#717070'
			                )
			              ">
										重置
									</div>
								</div>
							</div>
						</div> -->
						<div class="block-item block-item-class">
							<span class="label">价格领取颜色</span>
							<div class="item-colorPicker">
								<div class="color-picker-box">
									<el-color-picker size="small" v-model="curItem.style.receiveTextColor"
										defaultColor="#fff" />
								</div>
								<div class="reset-color">
									<div class="ipt">
										<SInput v-model="curItem.style.receiveTextColor" width="100px" height="32px"
											border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
									</div>
									<div class="color-txt" @click="
			                onEditorResetColor(
			                  curItem.style,
			                  'receiveTextColor',
			                  '#ffffff'
			                )
			              ">
										重置
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- </el-tab-pane>
			</el-tabs> -->
				</div>

			<!-- 头条快报 -->
			<div v-if="curItem.type == 'special'" class="editor-content editor-content-banner">
				<!-- <el-tabs>
          <el-tab-pane key="1" label="内容设置"> -->
				<div class="block-box">
					<!-- <div class="block-title">内容展示</div> -->
					<div class="block-item flex flex-y-center block-item-class">
						<span class="label">头条图片</span>
						<span class="tips-wrap">建议尺寸140 × 38</span>
						<SImage v-model="curItem.params.image" :width="60" :height="60" />
					</div>
					<div class="block-item block-item-class">
						<span class="label">显示行数</span>
						<el-radio-group v-model="curItem.params.display" type="button">
							<el-radio :label="1">单行</el-radio>
							<el-radio :label="2">双行</el-radio>
						</el-radio-group>
					</div>
				</div>
				<div class="block-box">
					<!-- <div class="block-title">数据来源</div> -->
					<div class="block-item block-item-class">
						<span class="label">文章分类</span>
						<SArticleCate v-model="curItem.params.auto.category" />
					</div>
					<div class="block-item block-item-class">
						<span class="label">显示数量</span>
						<div class="block-item-right flex_c_s">
							<el-input size="small" class="flex1" v-model="curItem.params.auto.showNum" :min="1"
								:max="20" />
							<span class="unit-text">
								<span>篇</span>
							</span>
						</div>
					</div>
				</div>
				<!-- </el-tab-pane>
          <el-tab-pane key="2" label="样式设置"> -->
				<div class="block-box">
					<!-- <div class="block-title">内容样式</div> -->
					<div class="block-item block-item-class">
						<span class="label">文字颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.textColor"
									defaultColor="#000000" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.textColor" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
                        onEditorResetColor(curItem.style, 'textColor', '#000')
                      ">
									重置
								</div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">背景颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.background" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.background" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
                        onEditorResetColor(curItem.style, 'background', '#fff')
                      ">
									重置
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="block-box">
					<!-- <div class="block-title">组件样式</div> -->
					<div class="block-item block-item-class">
						<span class="label">上下边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingTop" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingTop')"
							v-model="curItem.style.paddingTop" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>

				</div>
				<!-- </el-tab-pane>
        </el-tabs> -->
			</div>

			<!-- 备案号 -->
			<div v-if="curItem.type == 'ICPLicense'" class="editor-content editor-content-banner">
				<!-- <el-tabs>
          <el-tab-pane key="1" label="内容设置"> -->
				<div class="sub-title">
					网站备案号请放到页面最底部，仅在H5端显示
				</div>
				<div class="block-box">
					<!-- <div class="block-title">文字内容</div> -->
					<div class="block-item block-item-class">
						<span class="label">内容</span>
						<el-input size="small" v-model="curItem.params.text" />
					</div>
					<div class="block-item mb-15 block-item-class">
						<span class="label">链接</span>
						<el-input size="small" v-model="curItem.params.link" />
					</div>
				</div>
				<!-- </el-tab-pane>
          <el-tab-pane key="2" label="样式设置"> -->
				<div class="block-box">
					<!-- <div class="block-title">内容样式</div> -->
					<div class="block-item block-item-class">
						<span class="label">文字大小</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.fontSize" :min="12" :max="24" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'fontSize')" v-model="curItem.style.fontSize"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">文字对齐</span>
						<el-radio-group v-model="curItem.style.textAlign" type="button">
							<el-radio label="left">居左</el-radio>
							<el-radio label="center">居中</el-radio>
							<el-radio label="right">居右</el-radio>
						</el-radio-group>
					</div>
					<div class="block-item block-item-class">
						<span class="label">文字颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.textColor" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.textColor" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
                        onEditorResetColor(
                          curItem.style,
                          'textColor',
                          '#696969'
                        )
                      ">
									重置
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="block-box">
					<!-- <div class="block-title">组件样式</div> -->
					<div class="block-item block-item-class">
						<span class="label">上下边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingTop" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingTop')"
							v-model="curItem.style.paddingTop" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">左右边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingLeft" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingLeft')"
							v-model="curItem.style.paddingLeft" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">背景颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.background" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.background" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
                        onEditorResetColor(curItem.style, 'background', '#fff')
                      ">
									重置
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- </el-tab-pane>
        </el-tabs> -->
			</div>

			<!-- 标题文本 -->
			<div v-if="curItem.type == 'title'" class="editor-content editor-content-banner">
				<!-- <el-tabs>
          <el-tab-pane key="1" label="内容设置"> -->
				<div class="block-box">
					<!-- <div class="block-title">标题内容</div> -->
					<div class="block-item block-item-class">
						<span class="label">标题文字</span>
						<el-input size="small" v-model="curItem.params.title" />
					</div>
					<div class="block-item block-item-class">
						<span class="label">标题大小</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.params.titleFontSize" :min="12" :max="18" />
						</div>
						<el-input type="number" @input="e=>changeInputParam(e,'titleFontSize')"
							v-model="curItem.params.titleFontSize" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">标题字体</span>
						<el-radio-group v-model="curItem.params.titleFontWeight" type="button">
							<el-radio label="normal">常规</el-radio>
							<el-radio label="bold">加粗</el-radio>
						</el-radio-group>
					</div>
				</div>
				<div class="block-box">
					<!-- <div class="block-title">描述内容</div> -->
					<div class="block-item block-item-class">
						<span class="label">描述文字</span>
						<el-input size="small" v-model="curItem.params.desc" />
					</div>
					<div class="block-item block-item-class">
						<span class="label">描述大小</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.params.descFontSize" :min="12" :max="18" />
						</div>
						<el-input type="number" @input="e=>changeInputParam(e,'descFontSize')"
							v-model="curItem.params.descFontSize" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">描述字体</span>
						<el-radio-group v-model="curItem.params.descFontWeight" type="button">
							<el-radio label="normal">常规</el-radio>
							<el-radio label="bold">加粗</el-radio>
						</el-radio-group>
					</div>
				</div>
				<div class="block-box">
					<!-- <div class="block-title">查看更多</div> -->
					<div class="block-item block-item-class">
						<span class="label">是否显示</span>
						<el-radio-group v-model="curItem.params.more.enable" type="button">
							<el-radio :label="true">显示</el-radio>
							<el-radio :label="false">隐藏</el-radio>
						</el-radio-group>
					</div>
					<div class="block-item block-item-class">
						<span class="label">文字内容</span>
						<el-input size="small" v-model="curItem.params.more.text" />
					</div>
					<div class="block-item block-item-class">
						<span class="label">箭头图标</span>
						<el-radio-group v-model="curItem.params.more.enableIcon" type="button">
							<el-radio :label="true">显示</el-radio>
							<el-radio :label="false">隐藏</el-radio>
						</el-radio-group>
					</div>
					<div class="block-item block-item-class">
						<span class="label">跳转链接</span>
						<SLink v-model="curItem.params.more.link" textAlign="right" />
					</div>
				</div>
				<!-- </el-tab-pane>
          <el-tab-pane key="2" label="样式设置"> -->
				<div class="block-box">
					<!-- <div class="block-title">内容样式</div> -->
					<div class="block-item block-item-class">
						<span class="label">标题文字颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.titleTextColor"
									defaultColor="#323233" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.titleTextColor" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
                        onEditorResetColor(
                          curItem.style,
                          'titleTextColor',
                          '#323233'
                        )
                      ">
									重置
								</div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">描述文字颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.descTextColor"
									defaultColor="#969799" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.descTextColor" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
                        onEditorResetColor(
                          curItem.style,
                          'descTextColor',
                          '#969799'
                        )
                      ">
									重置
								</div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">更多文字颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.moreTextColor"
									defaultColor="#969799" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.moreTextColor" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
                        onEditorResetColor(
                          curItem.style,
                          'moreTextColor',
                          '#969799'
                        )
                      ">
									重置
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="block-box">
					<!-- <div class="block-title">组件样式</div> -->
					<div class="block-item block-item-class">
						<span class="label">组件背景</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.background" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.background" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
			            onEditorResetColor(curItem.style, 'background', '#fff')
			          ">
									重置
								</div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">上边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingY" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingY')" v-model="curItem.style.paddingY"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">下边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingY1" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingY1')" v-model="curItem.style.paddingY1"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">左边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingX" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingX')" v-model="curItem.style.paddingX"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">右边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingX1" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingX1')" v-model="curItem.style.paddingX1"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>

				</div>
				<!-- </el-tab-pane>
        </el-tabs> -->
			</div>
		</template>
	</div>
</template>

<script>
	import Vue from "vue";
	import OSS from "ali-oss";
	import COS from 'cos-js-sdk-v5';
	// import vcolorpicker from 'vcolorpicker'
	// import PropTypes from 'ant-design-vue/es/_util/vue-types'
	import draggable from "vuedraggable";
	// import { inArray } from '@/utils/util'
	// import { Ueditor, SelectCategory } from '@/components'
	import TinymceEditor from "@/components/TinymceEditor/TinymceEditor";
	import {
		STan,
		SMarks,
		SMarksup,
		SCouponpack,
		SImage,
		SArticleCate,
		SGoods,
		SLink,
		SHotZone,
		SCoupon,
		SInput,
		SGoodsCate,
		SLive1,
		SstoreCate,
		SGoodsCatePointe,
		SGoodsPointe
	} from "./modules";
	// Vue.use(vcolorpicker)
	export default {
		props: {
			// 页面装修默认数据
			defaultData: {},
			// 页面数据
			data: {},
			// 当前选中的元素
			curItem: {},
			// 当前选中的元素索引
			selectedIndex: 0,
		},
		components: {
			SCouponpack,
			draggable,
			SMarks,
			SMarksup,
			SGoodsPointe,
			SGoodsCatePointe,
			// Ueditor,
			TinymceEditor,
			SImage,
			SArticleCate,
			SGoods,
			// SelectCategory,
			SLink,
			SHotZone,
			SCoupon,
			SInput,
			SLive1,
			SGoodsCate,
			SstoreCate
		},
		data() {
			return {
				projectinfo: {
					id: "",
					title: "", //站点名称
					image: "", //站点图标，本地上传文件
					image_url: "", //站点整站图片  本地上传
					description: "", //技术支持
					agreement_title: "", //协议标题
					agreement_content: "", //协议内容
					about_content: "", //站点图标地址
					privacy_content: "", //站点整站图片地址
					is_open: "",
					qiniuToken: "", //视频上传的token
					settingInfo: {},
				},
			};
		},
		beforeCreate() {
			// this.inArray = inArray
		},
		created() {
			this.axios.get("/api/shop/basic/shop-info").then((res) => {
				if (res.code == 200 && res.data) {
					this.projectinfo = res.data;
				}
			});
			let _this = this;
			// 获取视频上传的token
			_this.axios.get("/api/common/upload-token").then((res) => {
				_this.qiniuToken = res.data.uptoken;
			});
			this.getInfo();
		},
		computed: {
			formattedValue(type) {
				console.log(type)
				// if(this.$util.inArray(type, all)){
				//   return true
				// }else{
				//   return false
				// }
			}
		},
		methods: {
			radioF(all, type) {
				if (this.$util.inArray(type, all)) {
					return true
				} else {
					return false
				}
			},
			radioFun(type, val) {
				this.curItem.style[type] = val
			},
			checkR(all, type, status) {
				if (status) {
					if (this.$util.inArray(type, all)) {

					} else {
						this.curItem.style.show.push(type)
					}
				} else {
					if (this.$util.inArray(type, all)) {
						this.curItem.style.show = this.curItem.style.show.filter(item => item !== type)
					}
				}
			},
			setFun(e) {
				this.curItem.style.navRadius = e
				// this.$forceUpdate()
			},
			changeInput(e, type) {
				this.curItem.style[type] = Number(e)
				// this.$nextTick()
			},
			changeInputParam(e, type) {
				this.curItem.params[type] = Number(e)
				// this.$nextTick()
			},
			changeGoods(e, type) {
				this.curItem.params.auto[type] = Number(e)
				// this.$nextTick()
			},
			// 定时关闭只能是大于0的整数
			handleTimeoutInput(value) {
				// 强制转换为正整数
				const num = Math.max(1, parseInt(value) || 1);
				if (value !== num.toString()) {
					this.data.page.params.timeout = num;
				}
			},
			// 移除视频
			handvideOff() {
				// this.post.video_id = "";
				// this.video_url = "";
				this.curItem.params.videoUrl = "";
			},
			// 获取设置
			getInfo() {
				let _this = this;
				_this.axios
					.get("/api/common/shop/admin/upload/setting/index")
					.then((res) => {
						if (res.code == 200) {
							if (res.data) {
								_this.settingInfo = res.data;
							}
						} else {
							eltips(res.msg, "error");
						}
					});
			},
			// 选择视频
			uploadFun(e) {
				let _this = this;
				var timestamp = Date.parse(new Date());
				var date = new Date(timestamp);
				// console.log("==现在时间==")
				var Y = date.getFullYear(); //年
				var M =
					date.getMonth() + 1 < 10 ?
					"0" + (date.getMonth() + 1) :
					date.getMonth() + 1; //月
				var D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate(); //日
				var h = date.getHours() < 10 ? "0" + date.getHours() : date.getHours(); //时
				var m =
					date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes(); //分
				var s =
					date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds(); //秒
				const file = this.$refs.fileInput.files[0]; // 获取input file选择的文件
				var tempFormat = file.name.substring(file.name.lastIndexOf(".") + 1);
				var filePath =
					"upload/video/" +
					Y +
					M +
					D +
					"/" +
					Y +
					M +
					D +
					h +
					m +
					s +
					"." +
					tempFormat;
				if (this.settingInfo.storage_type == 1) {
					const formData = new FormData(); // 发送至服务器的数据
					formData.append("file", file); // 添加文件数据到formData
					formData.append("file_type", "file"); // 添加文件数据到formData
					formData.append("key", filePath); // 添加文件数据到formData
					formData.append("token", this.qiniuToken); // 添加文件数据到formData
					// 七牛云
					this.axios.post("https://up-z2.qiniup.com", formData).then((res) => {
						_this.axios
							.post("/api/common/upload-video", {
								file_hash: res.hash,
								file_key: res.key,
								origin_name: "test.mp4",
							})
							.then((resd) => {
								console.log("resd", resd);
								if (resd.code == 200) {
									_this.curItem.params.videoUrl = resd.data.url;
								} else {
									eltips(res.msg, "error");
								}
							});
					});
				} else if (this.settingInfo.storage_type == 2) {
					// 腾讯COS
					this.uploadVideoToCOS(file, filePath);
				} else if (this.settingInfo.storage_type == 3) {
					// 阿里云OSS
					this.handleFileChange(file, filePath);
				}
			},
			// 腾讯云
			async uploadVideoToCOS(file, filePath) {
				let _this = this
				let cos = new COS({
					SecretId: this.settingInfo.access_key, // 替换为你的SecretId
					SecretKey: this.settingInfo.secret_key, // 替换为你的SecretKey
				});
				cos.putObject({
						Bucket: this.settingInfo.bucket,
						Region: this.settingInfo.region,
						Key: filePath,
						Body: file,
					},
					(err, data) => {
						if (err) {
							_this.$refs.fileInput.value = null;
						} else {
							_this.axios
								.post("/api/common/upload-video", {
									file_hash: filePath,
									file_key: filePath,
									origin_name: file.name,
								})
								.then((res) => {
									if (res.code == 200) {
										_this.curItem.params.videoUrl = res.data.url;
									} else {
										eltips(res.msg, "error");
									}
									_this.$refs.fileInput.value = null;
								});
							console.log("data:::", data);
						}
					}
				);
			},
			// 阿里云
			async handleFileChange(event, filePath) {
				let file = event;
				let _this = this;
				const client = new OSS({
					region: this.settingInfo.region.split(".")[0], // 设置Bucket所在地域，例如'oss-cn-hangzhou'
					accessKeyId: this.settingInfo.access_key,
					accessKeySecret: this.settingInfo.secret_key,
					bucket: this.settingInfo.bucket, // 设置Bucket名称//存储空间
				});
				const result = await client.put(filePath, file); // 上传文件到指定的路径下
				_this.axios.post("/api/common/upload-video", {
						file_hash: filePath,
						file_key: filePath,
						origin_name: "test.mp4",
					})
					.then((resd) => {
						if (resd.code == 200) {
							_this.curItem.params.videoUrl = resd.data.url;
						} else {
							eltips(res.msg, "error");
						}
					});
			},
			goodChange(e) {
				if (e == 'auto') {
					if (this.curItem.type == 'pointergoods') {
						this.getPointValue('')
					} else {
						this.getValue('')
					}
				}
			},
			// 获取当前商品分类的数据
			getPointValue(e) {
				this.curItem.params.auto.category = e;
				let _this = this;
				_this.axios
					.get("/api/weishop/admin/plugin/points/goods/index", {
						params: {
							categoryId: e,
							page: 1,
							limit: this.curItem.params.auto.showNum,
						},
					})
					.then((res) => {
						if (res.code == 200) {
							this.curItem.defaultData = res.data.data;
						} else {
							eltips(res.msg, "error");
						}
					});
			},
			// 获取当前商品分类的数据
			getValue(e) {
				let inds = ''
				let limit = 10
				if(this.curItem.type=='tabgoods'){
					this.curItem.params.tab.map((reds,index)=>{
						if(reds.index == this.curItem.params.tabVals){
							limit = reds.auto.showNum
							inds = index
						}
					})
				}else{
					limit = this.curItem.params.auto.showNum
				}
				console.log("indsindsindsinds",inds)
				if(this.curItem.type=='tabgoods'){
					this.curItem.params.tab[inds].auto.category = e;
				}else{
					this.curItem.params.auto.category = e;
				}
				
				let _this = this;
				_this.axios
					.get("/api/weishop/admin/goods/list", {
						params: {
							categoryId: e,
							page: 1,
							limit: limit,
						},
					})
					.then((res) => {
						if (res.code == 200) {
							if(this.curItem.type=='tabgoods'){
								this.curItem.params.tab[inds].defaultGoods = res.data.data;
								console.log("this.curItem.params.tab",res.data.data)
								console.log("this.curItem.params.tab",this.curItem.params.tab)
							}else{
								this.curItem.defaultData = res.data.data;
							}
						} else {
							eltips(res.msg, "error");
						}
					});
			},
			activeSeckill(e) {
				this.curItem.super_data.id = e.id;
				this.curItem.super_data.end_time = e.end_time;
				this.curItem.super_data.name = e.name;
				this.curItem.super_data.start_time = e.start_time;
				let _this = this;
				_this.axios.get("/api/weishop/admin/market/super/show/" + e.id)
					.then((res) => {
						console.log("我在打印页面详情", res);
						console.log("我在完成赋值", this.curItem);
						if (res.code == 200) {
							this.curItem.data = (res.data.data.length > 4 ? res.data.data.slice(0, 4) : res.data.data);
						} else {
							eltips(res.msg, "error");
						}
					});
			},
			activeCouponpack(e) {
				let _this = this;
				_this.axios.get("/api/weishop/admin/plugin/couponpack/detail/" + e.id)
					.then((res) => {
						if (res.code == 200) {
							this.curItem.data = res.data.coupon;
						} else {
							eltips(res.msg, "error");
						}
					});
			},
			// 广告
			handleAddAd(max = 1) {
				this.data.page.params.adsList.push({
					imgUrl: "https://mp.mocols.com/common/admin/admin_banner.jpg ",
					imgName: "image-1.jpg",
					link: null,
				})
			},
			handleDeleleAd(index) {
				// if (curItem.data.length <= 1) {
				//   this.$message.warning("至少保留一个");
				//   return false;
				// }
				this.data.page.params.adsList.splice(index, 1);
			},
			// 新增数据
			handleAddData(max = 1) {
				const {
					defaultData,
					curItem
				} = this;
				const newDataItem = defaultData.items[curItem.type].data[0];
				curItem.data.push(_.cloneDeep(newDataItem));
			},
			/**
			 * 编辑器删除data元素
			 * @param curItem
			 * @param index
			 */
			handleDeleleData(curItem, index) {
				if (curItem.data.length <= 1) {
					this.$message.warning("至少保留一个");
					return false;
				}
				curItem.data.splice(index, 1);
			},
			// 新增数据
			handleAddSwipter(max = 1) {
				const {
					curItem
				} = this;
				curItem.swipter.push({
					imgUrl: "https://qiniuyun.mocols.com/upload/images/20250314/202503141448459974.png",
					imgName: "image-1.jpg",
					link: null,
				});
			},
			/**
			 * 编辑器删除data元素
			 * @param curItem
			 * @param index
			 */
			handleDeleleSwipter(curItem, index) {
				// if (curItem.swipter.length <= 1) {
				//   this.$message.warning("至少保留一个");
				//   return false;
				// }
				curItem.swipter.splice(index, 1);
			},

			/**
			 * 重置颜色
			 * @param holder
			 * @param attribute
			 * @param color
			 */
			onEditorResetColor(holder, attribute, color) {
				holder[attribute] = color;
			},
			randomString(length) {
				let result = '';
				while (result.length < length) {
					// 生成 0~1 的随机数，转 36 进制，去掉 "0."，取所需长度
					result += Math.random().toString(36).substring(2);
				}
				return result.substring(0, length);
			},
			handleTabsEdit(targetName, action) {
				if (action == 'add') {
					let randomVal = this.randomString(6)
					this.curItem.params.tabVals = randomVal
					this.curItem.params.tab.push({
						index: randomVal,
						title: '名称',
						sub: '副标题',
						goods:[],
						defaultGoods:[],
						swipter: [],
						source: "auto",
						auto: {
							category: 0,
							goodsSort: "all",
							showNum: 6,
						},
					})
				}

				if (action == 'remove') {
					let ind = ''
					let activeName = this.curItem.params.tabVals
					this.curItem.params.tab.map((e, index) => {
						if (e.index == targetName) {
							let nextTab = this.curItem.params.tab[index + 1] || this.curItem.params.tab[index - 1];
							if (nextTab) {
								activeName = nextTab.name;
							}
							ind = index
						}
					})
					this.curItem.params.tabVals = activeName;
					this.curItem.params.tab.splice(ind, 1)
				}
			}
		},
	};
</script>
<style lang="less" scoped>
	@import "./style.less";
	@import "./iconfont_uni.css";
	::v-deep .tabgoods_box .el-tabs--border-card{
		border:0;
		box-shadow:0 0 0 #fff
	}
	::v-deep .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active{
		border:0
	}
	::v-deep .el-tabs__item.is-active {
		font-weight: bold;
	}
	::v-deep .el-tabs__new-tab{
		margin:12px 10px 9px 10px
	}
	::v-deep .el-tabs__item .el-icon-close{
		padding-top:3px
	}

	::v-deep .el-tabs__header {
		border-bottom: 1px solid #f5f5f5 !important;
		display: flex;
		justify-content: flex-start;
	}

	::v-deep .el-tabs__active-bar {
		height: 2px;
	}

	::v-deep .el-tabs__nav-wrap::after {
		content: "";
		height: 0;
		background-color: none;
	}
	
	.navstyle ::v-deep .ivu-radio-group-button {
		border: 0 !important
	}

	.navstyle ::v-deep .ivu-radio-group-button .ivu-radio-wrapper:first-child {
		border: 0 !important
	}

	.navstyle ::v-deep .ivu-radio-group-button .ivu-radio {
		display: none !important
	}

	.navstyle ::v-deep .ivu-radio-group-button .ivu-radio-wrapper {
		border: 0 !important
	}

	.navstyle ::v-deep .ivu-radio-group-button .ivu-radio-wrapper:after,
	.ivu-radio-group-button .ivu-radio-wrapper:before {
		width: 0 !important
	}

	.modeItem {
		margin-left: 10px;
		border-left: 1px solid #e4e4e4;
	}

	.block-item ::v-deep .input_text {
		width: 30px;
	}

	.block-item ::v-deep .el-input__inner {
		padding: 0 10px
	}

	.s_radio {
		height: 16px;
		width: 16px;
		display: block;
		border: 1px solid #E4E7ED;
		border-radius: 50% 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 14px;
	}

	.s_radio_y {
		height: 16px;
		width: 16px;
		display: block;
		border: 1px solid #006aff;
		border-radius: 50% 50%;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.s_radio_active {
		height: 10px;
		width: 10px;
		border-radius: 50% 50%;
		display: block;
		background: #006aff;
		position: reactive;

	}

	.s_r {
		cursor: pointer;
		margin-right: 20px;
		align-items: center;
		display: flex;
		align-items: center;
	}

	.dancheck ::v-deep .ivu-radio-group-button .ivu-radio-wrapper {
		padding: 0 8px;
	}
</style>